var pn = Object.defineProperty;
var bn = (e, t, r) => t in e ? pn(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var oe = (e, t, r) => bn(e, typeof t != "symbol" ? t + "" : t, r);
import * as w from "react";
import A, { useEffect as pe, useRef as ue, createContext as fn, useState as we, useContext as cr, useLayoutEffect as dr, createElement as at } from "react";
import { observer as hn } from "mobx-react";
import { makeObservable as Sn, observable as gn, action as vn } from "mobx";
const ot = (e) => ({
  marketId: e.marketId,
  eventId: e.eventId,
  selectionId: e.id,
  categoryId: e.categoryId,
  subCategoryId: e.subCategoryId
}), ee = (e) => {
  const { selection: t, eventId: r, localization: n, categoryId: s, subCategoryId: o, isDisabled: i } = e;
  return {
    eventId: r,
    categoryId: s,
    subCategoryId: o,
    id: t.id,
    outcomeType: t.outcomeType,
    marketName: t.marketName,
    label: t.label,
    trueOdds: t.trueOdds,
    points: n.formatPoints(t),
    metadata: t.metadata,
    isDisabled: i || !1,
    marketId: t.marketId,
    displayOdds: t.displayOdds,
    tags: t.tags,
    sortOrder: t.sortOrder,
    participants: t.participants || []
  };
}, it = (e) => {
  const t = ee(e), { onSelectionClick: r, selectedSelectionIndex: n, loadingSelectionIndex: s } = e;
  return {
    ...t,
    selectionHandlerIDs: ot(t),
    onSelectionClick: r,
    isLoading: s == null ? void 0 : s.getData(t.id),
    isSelected: (n == null ? void 0 : n.getData(t.id)) && !(s != null && s.getData(t.id))
  };
}, U = {
  Columns_1: "1-column",
  Columns_2: "2-columns",
  Columns_3: "3-columns",
  Columns_4: "4-columns",
  Columns_5: "5-columns",
  Columns_6: "6-columns",
  Columns_7: "7-columns",
  Columns_2_ReverseWidth: "2-columns-reverse-width",
  Columns_2_SmallCells: "2-columns-small-cells",
  Columns_2_BigCells: "2-columns-big-cells",
  Columns_3_NoRowLabels: "3-columns-no-row-labels",
  Columns_3_NoHeaderLabels: "3-columns-no-header-labels",
  Columns_4_NoHeaderLabels: "4-columns-no-header-labels"
};
var Qe = /* @__PURE__ */ ((e) => (e.DualGrid = "row-label-long", e.FixedGrid = "grid-fixed-location", e))(Qe || {});
const Ft = {
  Home: 1,
  Away: 2,
  "1X": 1,
  12: 2,
  Over: 1,
  Under: 2,
  Yes: 1,
  No: 2,
  Odd: 1,
  Even: 2,
  ToScoreFirst: 1,
  ToScoreAnyTime: 2,
  ToScoreFirstOrLast: 1,
  ToScore3OrMore: 2
}, Ie = {
  Home: 1,
  Away: 3,
  Tie: 2,
  Draw: 2,
  "1X": 1,
  X2: 2,
  12: 3,
  Over: 1,
  Exactly: 2,
  Under: 3,
  Yes: 1,
  No: 2,
  Odd: 1,
  Even: 2,
  ToScoreFirst: 1,
  ToScoreLast: 2,
  ToScoreAnyTime: 3,
  ToScoreFirstOrLast: 1,
  ToScore2OrMore: 2,
  ToScore3OrMore: 3
}, Gt = {
  Tie: ["Home", "Tie", "Away"],
  Draw: ["Home", "Draw", "Away"],
  X2: ["1X", "X2", "12"],
  Exactly: ["Over", "Exactly", "Under"],
  ToScoreLast: ["ToScoreFirst", "ToScoreLast", "ToScoreAnyTime"],
  ToScore2OrMore: ["ToScoreFirstOrLast", "ToScore2OrMore", "ToScore3OrMore"]
}, Wt = {
  Home: ["Home", "Away"],
  Away: ["Home", "Away"],
  "1X": ["1X", "12"],
  12: ["1X", "12"],
  Yes: ["Yes", "No"],
  No: ["Yes", "No"],
  Over: ["Over", "Under"],
  Under: ["Over", "Under"],
  Odd: ["Odd", "Even"],
  Even: ["Odd", "Even"],
  ToScoreFirst: ["ToScoreFirst", "ToScoreAnyTime"],
  ToScoreAnyTime: ["ToScoreFirst", "ToScoreAnyTime"],
  ToScoreFirstOrLast: ["ToScoreFirstOrLast", "ToScore3OrMore"],
  ToScore3OrMore: ["ToScoreFirstOrLast", "ToScore3OrMore"]
};
function yn(e) {
  return e ? {
    2: {
      ...Ft,
      Home: 2,
      Away: 1
    },
    3: {
      ...Ie,
      Home: 3,
      Away: 1
    }
  } : {
    2: Ft,
    3: Ie
  };
}
function xn(e) {
  return Gt[e.find((t) => Gt[t])] || Wt[e.find((t) => Wt[t])];
}
function lt(e, t, r) {
  const n = yn(r)[t.size];
  return Object.entries(e).sort(([s], [o]) => n[s] - n[o]);
}
function ct(e) {
  const t = !e.mapToRowLabel, r = e.mapToHeaderLabel, n = e.reverseTemplateColumnsWidth, s = e.outcomeTypes.size + (t ? 0 : 1);
  return `Columns_${s}${s === 3 && t && r ? "_NoRowLabels" : ""}${n ? "_ReverseWidth" : ""}`;
}
function et(e) {
  const t = [];
  return e.mapToHeaderLabel && t.push(..._n(e.mapToHeaderLabel, e.sortedGroups, e.hasMarketWithAllOutcomes)), e.groups.forEach((r) => {
    dt({
      cells: t,
      config: e,
      sortedGroupKeys: e.sortedGroups,
      getSelection: (n) => wn(r, n)
    });
  }), t;
}
function Cn(e) {
  const t = [];
  return e.mapToNameLabel && t.push(e.mapToNameLabel()), e.swappedGroups.forEach(([r, n]) => {
    e.mapToHeaderLabel && t.push(
      e.mapToHeaderLabel(
        n.find((s) => {
          var o, i;
          return ((i = (o = s.participants) == null ? void 0 : o[0]) == null ? void 0 : i.name) === r;
        })
      )
    );
  }), e.lineNumbers.forEach((r) => {
    dt({
      cells: t,
      config: e,
      sortedGroupKeys: e.swappedGroups,
      getSelection: (n) => mr(e.groups, n, r)
    });
  }), t;
}
function ur(e) {
  const t = [];
  return e.mapToNameLabel && t.push(e.mapToNameLabel()), e.sortedGroups.forEach(([r, n]) => {
    const s = n.find((o) => o.outcomeType === r);
    s && e.mapToHeaderLabel && t.push(e.mapToHeaderLabel(s));
  }), e.lineNumbers.forEach((r) => {
    dt({
      cells: t,
      config: e,
      sortedGroupKeys: e.sortedGroups,
      getSelection: (n) => mr(e.groups, n, r)
    });
  }), t;
}
function dt(e) {
  const t = [], r = [], n = [];
  e.sortedGroupKeys.forEach(([s]) => {
    const o = e.getSelection(s);
    if (!o) {
      e.config.mapToEmptyButton && t.push(e.config.mapToEmptyButton(`${e.cells.length + t.length}-${s}`));
      return;
    }
    e.config.mapToRowLabel && !r.length && r.push(e.config.mapToRowLabel(o)), e.config.mapToButtonExpandable && !n.length && n.push(e.config.mapToButtonExpandable()), e.config.mapToButton && t.push(e.config.mapToButton(o));
  }), e.cells.push(...r, ...n, ...t);
}
function wn(e, t) {
  return e[t];
}
function _n(e, t, r) {
  return r ? t.map(
    ([n, s]) => e(s || { label: n })
  ) : t.map(([, n]) => e(n));
}
function mr(e, t, r) {
  return e[t][r];
}
function ut(e) {
  return e.map((t, r) => r);
}
function kn(e, t) {
  return t ? Object.entries(e).reverse() : Object.entries(e);
}
const te = (e, t) => {
  const r = e.sortOrder - t.sortOrder;
  return r === 0 ? e.id.localeCompare(t.id) : r;
};
function Tn(e, t) {
  return e.sortOrder !== t.sortOrder ? e.sortOrder - t.sortOrder : e.trueOdds - t.trueOdds;
}
const En = {
  Home: (e, t) => Oe(e, !t),
  Away: (e, t) => Oe(e, t),
  Over: (e) => Oe(e, !0),
  Under: (e) => Oe(e, !0)
};
function Oe(e, t) {
  return e.slice().sort(
    (r, n) => t ? Number(r.points) - Number(n.points) : Number(n.points) - Number(r.points)
  );
}
const Nn = (e) => e.slice().sort((t, r) => te(t, r)), pr = (e) => {
  const t = /* @__PURE__ */ new Map();
  return e.forEach((r) => {
    const n = t.get(r.label);
    n ? n[r.outcomeType] = r : t.set(r.label, { [r.outcomeType]: r });
  }), t;
}, On = (e) => {
  let t = 0, r;
  const n = /* @__PURE__ */ new Map(), s = e.reduce((c, d) => (d.outcomeType && c.add(d.outcomeType), c), /* @__PURE__ */ new Set()), i = [...(xn([...s.values()]) || []).values()].reduce((c, d) => (c[d] = void 0, c), {});
  return e.forEach((c) => {
    r && Ie[c.outcomeType] <= Ie[r.outcomeType] && t++;
    const d = n.get(`${t}`);
    d ? d[c.outcomeType] = c : n.set(`${t}`, { ...i, [c.outcomeType]: c }), r = c;
  }), n;
}, jn = (e) => e.reduce((r, n) => {
  var i, c;
  const s = ((i = n == null ? void 0 : n.participants[0]) == null ? void 0 : i.id) || ((c = n == null ? void 0 : n.participants[0]) == null ? void 0 : c.name), o = n != null && n.outcomeType && s ? n.outcomeType : "Tie";
  return r[o] = r[o] || [], r[o].push(n), r;
}, {}), Ln = (e, t) => {
  const r = e.reduce((n, s) => {
    const o = s.outcomeType || s.label;
    return n[o] = n[o] || [], n[o].push(s), n;
  }, {});
  return Object.keys(r).forEach((n) => {
    const s = En[n] ?? Nn;
    r[n] = s(r[n], t);
  }), r;
}, In = (e) => {
  const t = /* @__PURE__ */ new Map();
  return e.forEach((r) => {
    const n = t.get(r.label);
    n ? n[r.marketName] = r : t.set(r.label, { [r.marketName]: r });
  }), t;
}, Rn = (e) => e.reduce((r, n) => {
  const s = n == null ? void 0 : n.participants[0].name;
  return r[s] = r[s] || [], r[s].push(n), r;
}, {}), ne = (e, t = !1, r = !1) => {
  const n = new Map(e.map((s) => [s.id, new Set(s.tags)]));
  return e.slice().sort((s, o) => {
    var d, u;
    if (s != null && s.shouldSkipSorting && (o != null && o.shouldSkipSorting))
      return 0;
    const i = (d = n.get(s.id)) == null ? void 0 : d.has("IgnoreSortOrderOnPush"), c = (u = n.get(o.id)) == null ? void 0 : u.has("IgnoreSortOrderOnPush");
    return i && c || r ? s.sortOrder - o.sortOrder : !i && !c && t ? s.name.localeCompare(o.name, void 0, {
      numeric: !0,
      sensitivity: "base"
    }) : 0;
  });
};
function mt(e) {
  const t = [...e.groupSelections(e.builderConfig.selections).values()], r = t.length === 0 ? /* @__PURE__ */ new Set() : new Set(Object.keys(t[t.length - 1])), n = t.find((o) => Object.keys(o).length === r.size) || {}, s = lt(n, r, e.isTeamSwap);
  return {
    key: e.key,
    templateName: "AutoGrid",
    columns: U[ct({ ...e, outcomeTypes: r })],
    cells: e.predDefinedHeaderCell ? [e.predDefinedHeaderCell, ...et({ groups: t, sortedGroups: s, ...e })] : et({ groups: t, sortedGroups: s, ...e })
  };
}
const Mn = (e) => {
  const t = Ln(e.builderConfig.selections, e.isTeamSwap), r = new Set(Object.keys(t)), n = lt(t, r, e.isTeamSwap), s = n.map(([, c]) => c), o = s.reduce(
    (c, d) => d.length > c.length ? d : c,
    []
  ), i = ut(o);
  return {
    key: e.key,
    templateName: "AutoGrid",
    columns: U[ct({ ...e, outcomeTypes: r })],
    cells: ur({ groups: t, sortedGroups: n, lineNumbers: i, ...e }),
    selections: s.flat()
  };
};
function Pn(e) {
  return {
    ...Mn(e),
    templateName: "MoveTheLineGrid",
    oddsStyle: e.builderConfig.oddsStyle,
    selectedOutcomes: e.selectedOutcomes,
    totalsHeading: e.totalsHeading,
    isPlayerStatsEnabled: e.isPlayerStatsEnabled,
    eventStatus: e.eventStatus
  };
}
const An = (e) => {
  const t = e.groupSelections(e.builderConfig.selections), r = new Set(Object.keys(t)), n = lt(t, r, e.isTeamSwap), s = n.map(([, i]) => i).reduce((i, c) => c.length > i.length ? c : i, []), o = ut(s);
  return {
    key: e.key,
    templateName: "AutoGrid",
    columns: U[ct({ ...e, outcomeTypes: r })],
    cells: ur({ groups: t, sortedGroups: n, lineNumbers: o, ...e })
  };
};
function $n(e) {
  const t = e.markets || [], n = ne(t, !1, !0).map((u) => u.name), s = [...e.groupSelections(e.builderConfig.selections).values()].sort((u, b) => {
    const m = n[0], p = m in u ? 1 : 0;
    return (m in b ? 1 : 0) - p;
  }), o = s.reduce(
    (u, b) => Object.assign(u, b),
    {}
  ), i = new Map(n.map((u, b) => [u, b])), c = Object.entries(o).sort(([u], [b]) => {
    const m = i.get(u), p = i.get(b);
    return m === void 0 ? 1 : p === void 0 ? -1 : m - p;
  }), d = c.length && c.length + 1;
  return {
    key: e.key,
    templateName: "AutoGrid",
    columns: U[`Columns_${d}`],
    cells: et({ groups: s, sortedGroups: c, ...e })
  };
}
const Dn = (e) => {
  const t = e.groupSelections(e.builderConfig.selections), r = kn(t, e.isTeamSwap), n = r.map(([, o]) => o).reduce((o, i) => i.length > o.length ? i : o, []), s = ut(n);
  return {
    key: e.key,
    templateName: "AutoGrid",
    columns: U[`Columns_${r.length}`],
    cells: Cn({ groups: t, swappedGroups: r, lineNumbers: s, ...e })
  };
}, re = (e, t) => ({
  id: e.id,
  type: "Button",
  props: {
    selectionHandlerIDs: ot(e),
    disabled: e.isDisabled,
    isSelected: t.selectedSelectionIndex.getData(e.id) && !t.loadingSelectionIndex.getData(e.id),
    isLoading: t.loadingSelectionIndex.getData(e.id),
    fixedGridLocation: t.fixedGridLocation,
    onClick: t.onSelectionClick,
    label: t.label,
    odds: e.displayOdds[t.oddsStyle],
    trueOdds: e.trueOdds,
    points: t.points || e.points
  }
}), br = (e, t) => ({
  id: e[0].id,
  type: "ButtonExpandable",
  props: {
    buttons: e.map((r) => ({
      selectionHandlerIDs: ot(r),
      disabled: r.isDisabled,
      isSelected: t.selectedSelectionIndex.getData(r.id) && !t.loadingSelectionIndex.getData(r.id),
      isLoading: t.loadingSelectionIndex.getData(r.id),
      fixedGridLocation: t.fixedGridLocation,
      onClick: t.onSelectionClick,
      label: t.getLabel ? t.getLabel(r) : r.label,
      points: r.points,
      odds: r.displayOdds[t.oddsStyle],
      trueOdds: r.trueOdds
    })),
    //TODO: pass collapsibleAnimationTransitionTimeout and animation from block config
    collapsibleAnimationTransitionTimeout: 300,
    animation: {
      duration: 300,
      ease: "ease-in-out"
    },
    btnExpandableColumns: t.btnExpandableColumns || 1
  }
}), me = (e, t) => ({
  id: e,
  type: "ButtonEmpty",
  props: t || {}
}), K = (e) => ({
  id: `label_${e.id}`,
  type: e.type || "Label",
  props: {
    isRowLabel: e.isRowLabel,
    label: e.label,
    playerId: e.playerId,
    textAlignModifier: e.textAlignModifier,
    subLabel: e.subLabel,
    isVerticalLabel: e.isVerticalLabel,
    seoIdentifier: e.seoIdentifier,
    participantType: e.participantType,
    stretchColumn: e.stretchColumn,
    statistic: e.statistic,
    teamScore: e.teamScore,
    renderEventNavLink: e.renderEventNavLink,
    renderSGPNavLink: e.renderSGPNavLink,
    parsedEventState: e.parsedEventState,
    tags: e.tags,
    startEventDate: e.startEventDate,
    logoUrl: e.logoUrl,
    consumerPageName: e.consumerPageName
  }
}), he = (e) => ({
  id: `name_label_${e.id}`,
  type: e.type || "LabelName",
  props: {
    label: e.label,
    isRowLabel: e.isRowLabel
  }
}), pt = (e) => ({
  id: `separator_${e.id}`,
  type: e.type,
  props: {}
}), Bn = ({
  parsedSelections: e,
  oddsStyle: t,
  isFirstMarket: r,
  leagueId: n,
  consumerPageName: s,
  isPlayerMarket: o
}) => ({
  id: "market-buttons-slider",
  type: "MarketButtonsSlider",
  props: {
    parsedSelections: e,
    oddsStyle: t,
    isFirstMarket: r,
    leagueId: n,
    consumerPageName: s,
    isPlayerMarket: o
  }
}), Hn = ({
  parsedSelections: e,
  participants: t,
  oddsStyle: r,
  isFirstMarket: n,
  consumerPageName: s,
  showTable: o,
  isTooltipEnabled: i,
  gridSize: c,
  isMarketSuspended: d
}) => ({
  id: "market-participants-scores",
  type: "MarketParticipantsScores",
  props: {
    parsedSelections: e,
    oddsStyle: r,
    isFirstMarket: n,
    consumerPageName: s,
    showTable: o,
    participants: t,
    isTooltipEnabled: i,
    gridSize: c,
    isMarketSuspended: d
  }
});
function je(e, t) {
  return e.find((r) => (r == null ? void 0 : r.outcomeType) === t || r.label === t);
}
function q(e, t) {
  return pe(e, t ?? []);
}
const Vt = {
  TAGS: {
    SPORTCAST_BET_BUILDER: "SportcastBetBuilder",
    SGP: "SGP"
  }
};
function Fn(e) {
  return e.includes(Vt.TAGS.SPORTCAST_BET_BUILDER) || e.includes(Vt.TAGS.SGP);
}
const ie = (e) => (e == null ? void 0 : e.type) === "Player" ? e == null ? void 0 : e.id : void 0;
function Gn(e) {
  const t = {
    ToScoreFirst: "First Scorer",
    ToScoreAnyTime: "Anytime Scorer",
    ToScoreLast: "Last Scorer",
    ToScoreFirstOrLast: "To score first or last",
    ToScore2OrMore: "To score 2 or more",
    ToScore3OrMore: "To score 3 or more"
  };
  return ne(e.markets).map(
    (r) => mt({
      key: r.id,
      isTeamSwap: e.isTeamSwap,
      builderConfig: {
        ...e,
        selections: [...r.selections.values()].sort(te).map(
          (n) => ee({
            ...e,
            selection: n,
            isDisabled: r.isSuspended
          })
        )
      },
      groupSelections: pr,
      mapToButton: (n) => re(n, {
        ...e,
        label: "",
        loadingSelectionIndex: e.loadingSelectionIndex,
        selectedSelectionIndex: e.selectedSelectionIndex,
        oddsStyle: e.oddsStyle
      }),
      mapToRowLabel: (n) => {
        var s, o, i, c, d;
        return K({
          id: n.id,
          isRowLabel: !0,
          label: n.label,
          textAlignModifier: "left",
          playerId: ie((s = n.participants) == null ? void 0 : s[0]),
          participantType: (i = (o = n.participants) == null ? void 0 : o[0]) == null ? void 0 : i.type,
          seoIdentifier: (d = (c = n.participants) == null ? void 0 : c[0]) == null ? void 0 : d.seoIdentifier
        });
      },
      mapToEmptyButton: me,
      mapToHeaderLabel: (n) => K({
        id: `${n.outcomeType}`,
        isRowLabel: !1,
        label: n.outcomeType ? t[n.outcomeType] : ""
      })
    })
  );
}
const Q = (e, t) => e || t;
function fr() {
  const e = /* @__PURE__ */ new WeakMap();
  return function(t, r) {
    e.has(t) && clearTimeout(e.get(t));
    const n = setTimeout(() => {
      e.delete(t), t();
    }, r);
    e.set(t, n);
  };
}
const hr = (e, t, r) => e && t && t[r] ? `${e}${t[r]}` : void 0, Wn = {
  STARTED: "STARTED",
  FINISHED: "FINISHED",
  NOT_STARTED: "NOT_STARTED"
}, Sr = (e) => e === Wn.NOT_STARTED, Vn = (e, t, r) => {
  var n;
  const s = (n = t == null ? void 0 : t.live) == null ? void 0 : n[0];
  if (!(!s || !r || Sr(e)))
    return s;
}, ge = (e, t, r) => {
  if (!(!t || !r || !Sr(e)))
    return t;
}, _e = ({
  eventStatus: e,
  statistics: t,
  isPlayerScoresEnabled: r,
  participantStatistic: n,
  isPlayerStatsEnabled: s
}) => Vn(e, t, r) || ge(e, n, s);
function Un(e, t, r) {
  return e ? [r, t] : [t, r];
}
function Ae(e) {
  return `${(e.outcomeType || "").charAt(0).toUpperCase()}`;
}
const zn = (e) => e.outcomeType && Yn.has(e.outcomeType) ? e.outcomeType : Ae(e), Yn = /* @__PURE__ */ new Set(["Yes", "No"]), $e = (e) => {
  const t = {
    id: "",
    name: "",
    type: ""
  }, r = e.participants.find((n) => n.type === "Player");
  return r ? {
    ...r,
    id: r.id || r.name
  } : t;
};
function Kn(e) {
  const t = /* @__PURE__ */ new Set([0, 1, 2]);
  e.forEach((n) => t.delete(n.sortOrder));
  const r = Array.from(t).map((n) => ({ name: "", sortOrder: n }));
  return [...e, ...r].sort((n, s) => n.sortOrder - s.sortOrder);
}
const Ut = {
  id: "",
  marketId: "",
  label: "",
  displayOdds: {
    american: "",
    decimal: "",
    fractional: ""
  },
  sortOrder: 0,
  trueOdds: 0
}, gr = (e, t) => {
  const r = e[0], n = r.label, s = t.findIndex((i) => i.name === n);
  return n === "Over" || s === 0 ? [r, Ut] : [Ut, r];
}, qn = (e) => {
  const t = /* @__PURE__ */ new Set([1, 2, 6]);
  return e.filter((r) => t.has(r.marketType.betOfferTypeId) ? (t.delete(r.marketType.betOfferTypeId), !0) : !1);
}, bt = (e) => e !== "0" ? e : "pk", Xn = (e) => {
  const t = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e);
  return t ? {
    r: parseInt(t[1], 16),
    g: parseInt(t[2], 16),
    b: parseInt(t[3], 16)
  } : null;
};
function Jn(e) {
  const t = e.markets.some((r) => r.selections.size === 2);
  return ne(e.markets, !0).map(
    (r, n) => mt({
      key: r.id,
      isTeamSwap: e.isTeamSwap,
      builderConfig: {
        ...e,
        selections: [...r.selections.values()].sort(te).map(
          (s) => ee({
            ...e,
            selection: s,
            isDisabled: r.isSuspended
          })
        )
      },
      groupSelections: On,
      mapToButton: (s) => re(s, {
        ...e,
        label: zn(s),
        loadingSelectionIndex: e.loadingSelectionIndex,
        selectedSelectionIndex: e.selectedSelectionIndex,
        oddsStyle: e.oddsStyle,
        points: s.points
      }),
      mapToRowLabel: (s) => {
        var i, c;
        const o = s.participants[0];
        return K({
          id: o.id || `artificial-${s.id}`,
          isRowLabel: !0,
          label: o.name,
          textAlignModifier: "left",
          playerId: ie(o),
          participantType: o.type,
          seoIdentifier: o.seoIdentifier,
          statistic: _e({
            eventStatus: e.eventStatus,
            statistics: r.statistics,
            isPlayerScoresEnabled: (i = e.featureFlags) == null ? void 0 : i["RLS-OSB-WEB-PlayerScoresEnabled"],
            participantStatistic: o == null ? void 0 : o.statistic,
            isPlayerStatsEnabled: (c = e.featureFlags) == null ? void 0 : c["RLS-OSB-WEB-PlayerStatsEnabled"]
          })
        });
      },
      mapToEmptyButton: me,
      predDefinedHeaderCell: n == 0 ? he({
        id: `header_name_label_${n}`,
        label: "Player",
        isRowLabel: !0
      }) : void 0,
      hasMarketWithAllOutcomes: t,
      mapToHeaderLabel: n == 0 ? (s) => K({
        id: (s == null ? void 0 : s.label) || `artificial-${n}`,
        isRowLabel: !1,
        label: (s == null ? void 0 : s.label) || ""
      }) : void 0
    })
  );
}
function vr(e) {
  return ne(e.markets).map((t) => {
    const r = [...t.selections.values()].sort(te).map(
      (o) => ee({
        ...e,
        selection: o,
        isDisabled: t.isSuspended
      })
    ), n = he({
      id: `name_label_${t.id}`,
      label: t.name
    });
    let s = !1;
    return r != null && r.find((o) => o.label.includes(",")) && (s = !0), {
      key: t.id,
      templateName: "AutoGrid",
      columns: s ? U.Columns_1 : U.Columns_2_SmallCells,
      cells: [
        n,
        ...r.reduce((o, i, c) => {
          var m, p;
          const d = (m = i.participants) == null ? void 0 : m[0], u = K({
            id: `label_${i.id}`,
            isRowLabel: !s,
            label: i.label,
            textAlignModifier: "left",
            playerId: ie(d),
            participantType: d == null ? void 0 : d.type,
            seoIdentifier: d == null ? void 0 : d.seoIdentifier,
            statistic: ge(
              e.eventStatus,
              d == null ? void 0 : d.statistic,
              (p = e.featureFlags) == null ? void 0 : p["RLS-OSB-WEB-PlayerStatsEnabled"]
            ),
            isVerticalLabel: s
          }), b = re(i, {
            ...e,
            label: "",
            loadingSelectionIndex: e.loadingSelectionIndex,
            selectedSelectionIndex: e.selectedSelectionIndex,
            oddsStyle: e.oddsStyle,
            points: i.points
          });
          return s && c !== 0 && o.push(
            he({
              id: `name_label_${i.id}`,
              label: t.name
            })
          ), o.push(u, b), s && o.push(
            pt({
              id: `pair_${i.id}`,
              type: "Separator"
            })
          ), o;
        }, [])
      ]
    };
  });
}
function Zn(e) {
  return ne(e.markets, !0).reduce(
    (r, n) => {
      var i, c;
      const s = [...n.selections.values()].sort(te).map(
        (d) => ee({
          ...e,
          selection: d,
          isDisabled: n.isSuspended
        })
      );
      if (s.length < 1) return r;
      const o = $e(s[0]);
      return [
        ...r,
        {
          key: n.id,
          templateName: "DualGrid",
          columns: U.Columns_2,
          cells: [
            K({
              id: n.id,
              isRowLabel: !0,
              label: o.name,
              textAlignModifier: "left",
              playerId: ie(o),
              participantType: o.type,
              seoIdentifier: o.seoIdentifier,
              statistic: _e({
                eventStatus: e.eventStatus,
                statistics: n.statistics,
                isPlayerScoresEnabled: (i = e.featureFlags) == null ? void 0 : i["RLS-OSB-WEB-PlayerScoresEnabled"],
                participantStatistic: o == null ? void 0 : o.statistic,
                isPlayerStatsEnabled: (c = e.featureFlags) == null ? void 0 : c["RLS-OSB-WEB-PlayerStatsEnabled"]
              })
            }),
            br(s, {
              ...e,
              label: "",
              loadingSelectionIndex: e.loadingSelectionIndex,
              selectedSelectionIndex: e.selectedSelectionIndex,
              oddsStyle: e.oddsStyle
            })
          ]
        }
      ];
    },
    []
  );
}
function Qn(e) {
  return ne(e.markets, !0).map((t) => {
    const r = [...t.selections.values()].sort(te).map(
      (o) => ee({
        ...e,
        selection: o,
        isDisabled: t.isSuspended
      })
    ), n = he({
      id: `name_label_${t.id}`,
      label: t.name
    }), s = r.length > 2;
    return {
      key: t.id,
      templateName: "AutoGrid",
      columns: U[`Columns_${s ? 3 : 2}`],
      cells: [
        n,
        ...r.reduce((o, i) => {
          const c = re(i, {
            ...e,
            label: i.label,
            loadingSelectionIndex: e.loadingSelectionIndex,
            selectedSelectionIndex: e.selectedSelectionIndex,
            oddsStyle: e.oddsStyle,
            points: i.points
          });
          return o.push(c), o;
        }, [])
      ]
    };
  });
}
function ft(e) {
  return ne(e.markets, !0).map((t) => {
    var i, c;
    const r = [...t.selections.values()].sort(te).map(
      (d) => ee({
        ...e,
        selection: d,
        isDisabled: t.isSuspended
      })
    ), n = r[0];
    if (!n)
      return {
        key: t.id,
        templateName: "AutoGrid",
        columns: e.columns || U.Columns_2,
        cells: []
      };
    const s = $e(n), o = K({
      id: `name_label_${t.id}`,
      isRowLabel: !0,
      stretchColumn: !0,
      label: t.name,
      textAlignModifier: "left",
      playerId: ie(s),
      participantType: s.type,
      seoIdentifier: s.seoIdentifier,
      statistic: _e({
        eventStatus: e.eventStatus,
        statistics: t.statistics,
        isPlayerScoresEnabled: (i = e.featureFlags) == null ? void 0 : i["RLS-OSB-WEB-PlayerScoresEnabled"],
        participantStatistic: s == null ? void 0 : s.statistic,
        isPlayerStatsEnabled: (c = e.featureFlags) == null ? void 0 : c["RLS-OSB-WEB-PlayerStatsEnabled"]
      })
    });
    return {
      key: t.id,
      templateName: "AutoGrid",
      columns: e.columns || U.Columns_2,
      cells: [
        o,
        ...r.reduce((d, u) => {
          const b = re(u, {
            ...e,
            label: u.label,
            loadingSelectionIndex: e.loadingSelectionIndex,
            selectedSelectionIndex: e.selectedSelectionIndex,
            oddsStyle: e.oddsStyle,
            points: bt(u.points)
          });
          return d.push(b), d;
        }, [])
      ]
    };
  });
}
function es(e) {
  return ft({ ...e, columns: U.Columns_3 });
}
function ht(e) {
  return ne(e.markets).map((t) => {
    const r = [...t.selections.values()].sort(te).map(
      (n) => ee({
        ...e,
        selection: n,
        isDisabled: t.isSuspended
      })
    );
    return {
      key: t.id,
      templateName: "AutoGrid",
      columns: e.columns || U.Columns_2,
      cells: [
        ...r.reduce((n, s) => {
          const o = re(s, {
            ...e,
            label: s.label,
            loadingSelectionIndex: e.loadingSelectionIndex,
            selectedSelectionIndex: e.selectedSelectionIndex,
            oddsStyle: e.oddsStyle,
            points: bt(s.points)
          });
          return n.push(o), n;
        }, [])
      ]
    };
  });
}
function ts(e) {
  return ht({
    ...e,
    columns: U.Columns_3
  });
}
function rs(e) {
  return ne(e.markets).map((t) => {
    const r = [...t.selections.values()].sort(te).map(
      (n) => ee({
        ...e,
        selection: n,
        isDisabled: t.isSuspended
      })
    );
    return mt({
      key: t.id,
      isTeamSwap: e.isTeamSwap,
      builderConfig: {
        ...e,
        selections: r
      },
      groupSelections: pr,
      mapToButtonExpandable: () => br(r, {
        ...e,
        label: "",
        getLabel: (n) => Ae(n),
        loadingSelectionIndex: e.loadingSelectionIndex,
        selectedSelectionIndex: e.selectedSelectionIndex,
        oddsStyle: e.oddsStyle,
        btnExpandableColumns: 2
      }),
      mapToRowLabel: (n) => {
        var o, i, c, d;
        const s = $e(n);
        return K({
          id: s.id || `artificial-${n.id}`,
          isRowLabel: !0,
          label: s.name,
          textAlignModifier: "left",
          playerId: ie(s),
          participantType: s.type,
          seoIdentifier: (i = (o = n.participants) == null ? void 0 : o[0]) == null ? void 0 : i.seoIdentifier,
          statistic: _e({
            eventStatus: e.eventStatus,
            statistics: t.statistics,
            isPlayerScoresEnabled: (c = e.featureFlags) == null ? void 0 : c["RLS-OSB-WEB-PlayerScoresEnabled"],
            participantStatistic: s == null ? void 0 : s.statistic,
            isPlayerStatsEnabled: (d = e.featureFlags) == null ? void 0 : d["RLS-OSB-WEB-PlayerStatsEnabled"]
          })
        });
      },
      reverseTemplateColumnsWidth: !0
    });
  });
}
const ns = (e, t) => e.name.toLowerCase().includes("total") ? Ae(t) : "", ss = {
  2: 2,
  1: 0,
  6: 1
}, as = (e) => e === "7", os = (e) => e === nt.STARTED;
function is(e) {
  const t = e.markets[0].sportId, r = e.markets[0].leagueId, n = e.logos[r], s = e.participants.filter((m) => m.type.toLowerCase() === "team").sort((m, p) => m.sortOrder === void 0 || p.sortOrder === void 0 ? 0 : m.sortOrder - p.sortOrder), o = qn(e.markets), i = o.map((m) => ({
    name: m.name.toLowerCase(),
    sortOrder: ss[m.marketType.betOfferTypeId]
  })), c = (i.length > 2 ? i.sort((m, p) => m.sortOrder - p.sortOrder) : Kn(i)).map((m) => m.name), d = o.reduce((m, p) => {
    const S = p.name.toLowerCase();
    return m[S] = p, m;
  }, {}), u = c.map((m, p) => {
    const S = d[m];
    return K({
      id: `${m}-${p}`,
      isRowLabel: !1,
      label: (S == null ? void 0 : S.name) || ""
    });
  });
  return s.map((m, p) => {
    var _, k, h;
    const S = as(t) && !os(e.eventStatus) ? (_ = m.metadata) == null ? void 0 : _.startingPitcherPlayerName : "", v = p === 0 ? [...u] : [];
    return {
      key: m.id || `${m.name}-${p}`,
      templateName: "AutoGrid",
      columns: U.Columns_4,
      cells: [
        ...v,
        K({
          id: `${m.name}-${p}`,
          type: "LabelParlay",
          isRowLabel: !0,
          label: m.name,
          textAlignModifier: "left",
          subLabel: S,
          teamScore: p === 0 ? (k = e == null ? void 0 : e.teamsScore) == null ? void 0 : k.firstTeamScore : p === 1 ? (h = e == null ? void 0 : e.teamsScore) == null ? void 0 : h.secondTeamScore : void 0,
          renderEventNavLink: e.renderEventNavLink,
          renderSGPNavLink: e.renderSGPNavLink,
          parsedEventState: e.parsedEventState,
          tags: e.tags,
          startEventDate: e.startEventDate,
          logoUrl: hr(e.staticS3Host, n == null ? void 0 : n.Teams, m.name),
          consumerPageName: e.consumerPageName
        }),
        ...c.map((g, x) => {
          const E = d[g], N = E ? [...E.selections.values()] : [], R = (N.length === 1 ? gr(N, s) : N.sort(te)).map(
            (D) => ee({
              ...e,
              selection: D,
              isDisabled: E.isSuspended
            })
          )[p];
          return R && R.id ? re(R, {
            ...e,
            label: ns(E, R),
            loadingSelectionIndex: e.loadingSelectionIndex,
            selectedSelectionIndex: e.selectedSelectionIndex,
            oddsStyle: e.oddsStyle,
            points: bt(R.points)
          }) : me(`${m.name}-${g}-${x}`);
        })
      ]
    };
  });
}
function yr(e) {
  return (t) => ne(t.markets).map((r) => {
    const n = [...r.selections.values()].sort(te).map(
      (u) => ee({
        ...t,
        selection: u,
        isDisabled: r.isSuspended
      })
    ), s = e.shouldMapToNameLabel ? () => he({
      id: `name_label_${r.id}`,
      label: r.name
    }) : void 0, o = je(n, "Even"), i = je(n, "Odd"), c = je(n, "Yes"), d = je(n, "No");
    return o && i || c && d ? Dn({
      key: r.id,
      isTeamSwap: t.isTeamSwap,
      builderConfig: {
        ...t,
        selections: n
      },
      groupSelections: Rn,
      mapToNameLabel: s,
      mapToHeaderLabel: (u) => {
        var b, m;
        return K({
          id: u.id,
          isRowLabel: !1,
          label: (m = (b = u == null ? void 0 : u.participants) == null ? void 0 : b[0]) == null ? void 0 : m.name
        });
      },
      mapToButton: (u) => re(u, {
        ...t,
        label: u.label,
        loadingSelectionIndex: t.loadingSelectionIndex,
        selectedSelectionIndex: t.selectedSelectionIndex,
        oddsStyle: t.oddsStyle,
        points: u.points
      }),
      mapToEmptyButton: me
    }) : An({
      key: r.id,
      isTeamSwap: t.isTeamSwap,
      builderConfig: {
        ...t,
        selections: n
      },
      groupSelections: jn,
      mapToNameLabel: s,
      mapToHeaderLabel: (u) => {
        var b, m;
        return K({
          id: u.id,
          isRowLabel: !1,
          label: (m = (b = u == null ? void 0 : u.participants) == null ? void 0 : b[0]) == null ? void 0 : m.name
        });
      },
      mapToButton: (u) => re(u, {
        ...t,
        label: u.label,
        loadingSelectionIndex: t.loadingSelectionIndex,
        selectedSelectionIndex: t.selectedSelectionIndex,
        oddsStyle: t.oddsStyle,
        points: u.points
      }),
      mapToEmptyButton: me
    });
  });
}
const ls = yr({ shouldMapToNameLabel: !1 });
function cs(e) {
  return ht(e);
}
const ds = yr({ shouldMapToNameLabel: !0 }), us = [1, 7], ms = (e) => e.sort((t) => t.venueRole === "Home" ? -1 : 1), zt = (e) => e.length > 1;
function ps(e) {
  let t = ne(e.markets);
  const r = zt(t), n = e.markets.flatMap((s) => [...s.selections.values()]).filter((s) => e.selectedSelectionIndex.getData(s.id)).map((s) => s.id);
  if (r) {
    const o = ms(e.participants).map((i) => e.markets.find((c) => c.name.includes(i.name))).filter((i) => !!i);
    zt(o) && (t = e.isTeamSwap ? o.reverse() : o);
  }
  return t.map(
    (s) => {
      var o;
      return Pn({
        key: s.id,
        isTeamSwap: e.isTeamSwap,
        selectedOutcomes: n,
        totalsHeading: r ? s.name : "",
        eventStatus: "NOT_STARTED",
        isPlayerStatsEnabled: (o = e.featureFlags) == null ? void 0 : o["RLS-OSB-WEB-PlayerStatsEnabled"],
        builderConfig: {
          ...e,
          selections: [...s.selections.values()].map(
            (i) => it({
              ...e,
              selection: i,
              isDisabled: s.isSuspended
            })
          )
        },
        mapToButton: (i) => re(i, {
          ...e,
          label: i.label,
          loadingSelectionIndex: e.loadingSelectionIndex,
          selectedSelectionIndex: e.selectedSelectionIndex,
          oddsStyle: e.oddsStyle,
          points: i.points === "0" && us.includes(s.marketType.betOfferTypeId) ? "pk" : i.points
        })
      });
    }
  );
}
function bs(e) {
  return ne(e.markets).map((t) => {
    const r = [...t.selections.values()].sort(te).map(
      (s) => ee({
        ...e,
        selection: s,
        isDisabled: t.isSuspended
      })
    ), n = r.some((s) => s.label.includes(",")) || !1;
    return {
      key: t.id,
      templateName: "AutoGrid",
      columns: n ? U.Columns_1 : U.Columns_2_SmallCells,
      cells: [
        ...r.reduce((s, o) => {
          var u, b;
          const i = (u = o.participants) == null ? void 0 : u[0], c = K({
            id: `label_${o.id}`,
            isRowLabel: !n,
            label: o.label,
            textAlignModifier: "left",
            playerId: ie(i),
            participantType: i == null ? void 0 : i.type,
            seoIdentifier: i == null ? void 0 : i.seoIdentifier,
            statistic: ge(
              e.eventStatus,
              i == null ? void 0 : i.statistic,
              (b = e.featureFlags) == null ? void 0 : b["RLS-OSB-WEB-PlayerStatsEnabled"]
            ),
            isVerticalLabel: n
          }), d = re(o, {
            ...e,
            label: "",
            loadingSelectionIndex: e.loadingSelectionIndex,
            selectedSelectionIndex: e.selectedSelectionIndex,
            oddsStyle: e.oddsStyle,
            points: o.points
          });
          return s.push(c, d), n && s.push(
            pt({
              id: `pair_${o.id}`,
              type: "Separator"
            })
          ), s;
        }, [])
      ]
    };
  });
}
const Yt = ["spread", "total", "moneyline"], St = (e) => e.name.toLowerCase().split(" ").reverse()[0], xr = (e) => St(e) === "total", Cr = (e) => e.split(" ").join("-").toLowerCase(), wr = (e) => {
  const t = xr(e) ? " & " : " v ";
  return e.name.split(" - ")[0].split(t);
}, fs = (e) => wr(e).map(Cr).join("_"), hs = (e) => {
  const t = e[0];
  return wr(t).map((n) => ({
    name: n,
    type: ""
  }));
}, Kt = (e) => e.reduce((t, r) => {
  const n = St(r);
  return t[n] = r, t;
}, {}), Ss = (e, t) => e.name.toLowerCase().includes("total") ? Ae(t) : "", gs = (e, t) => {
  const r = e.map((n) => t.find((s) => {
    var o, i;
    return ((i = (o = s.participants) == null ? void 0 : o[0]) == null ? void 0 : i.name) === n.name;
  })).filter((n) => !!n);
  return r.length ? r : t.sort(te);
};
function vs(e) {
  const t = e.markets.filter((i) => i.tags && i.tags.includes("H2H")).map((i) => ({ ...i, isTotal: xr(i) })), r = {}, n = /* @__PURE__ */ new Map();
  t.forEach((i) => {
    const c = [...i.selections.values()], d = fs(i), b = [...n.get(d) || [], i];
    n.set(d, b), !(!c.length || i.isTotal) && c.forEach((m) => {
      const p = m.participants && m.participants[0];
      if (p && p.id) {
        const S = Cr(p.name);
        r[S] = p;
      }
    });
  });
  const s = Yt.map((i, c) => {
    const u = Kt(t)[i], b = u != null && u.name ? St(u) : "";
    return K({
      id: (u == null ? void 0 : u.id) || `${i}-${c}`,
      isRowLabel: !1,
      label: b
    });
  });
  return [...n.entries()].flatMap(([i, c], d) => {
    const u = i.split("_").map((S) => r[S]).filter((S) => S), b = u.length === 2 ? u : hs(c), m = Kt(c);
    return b.map((S, v) => {
      var h;
      const C = he({
        id: `header_name_label_${v}`,
        label: "Player",
        isRowLabel: !0
      }), _ = d === 0 && v === 0 ? [C, ...s] : [], k = {
        key: `${S.name}-${d}`,
        templateName: "AutoGrid",
        columns: U.Columns_4,
        cells: [
          ..._,
          K({
            id: `${S.name}`,
            isRowLabel: !0,
            label: S.name,
            textAlignModifier: "left",
            playerId: ie(S),
            seoIdentifier: S.seoIdentifier,
            participantType: S.type,
            statistic: ge(
              e.eventStatus,
              S == null ? void 0 : S.statistic,
              (h = e.featureFlags) == null ? void 0 : h["RLS-OSB-WEB-PlayerStatsEnabled"]
            )
          }),
          ...Yt.map((g) => {
            const x = m[g], E = x ? [...x.selections.values()] : [], j = (E.length === 1 ? gr(E, b) : gs(b, E)).map(
              (P) => ee({
                ...e,
                selection: P,
                isDisabled: x.isSuspended
              })
            )[v];
            return j && j.id ? re(j, {
              ...e,
              label: Ss(x, j),
              loadingSelectionIndex: e.loadingSelectionIndex,
              selectedSelectionIndex: e.selectedSelectionIndex,
              oddsStyle: e.oddsStyle,
              points: j.points
            }) : me(`${S.name}-${g}-${v}`);
          })
        ]
      };
      return v % 2 === 1 && d + 1 < n.size && k.cells.push(
        pt({
          id: `pair_${d}`,
          type: "Separator"
        })
      ), k;
    });
  });
}
function ys(e) {
  const t = e.markets.map((r) => [
    ...Array.from(r.selections.values()).map((n) => ({
      ...n,
      marketName: r.name,
      isDisabled: r.isSuspended,
      sortOrder: r.sortOrder
    }))
  ]).flat();
  return [
    $n({
      key: "autoGridMapperByNameForDynamicOutcomes",
      isTeamSwap: e.isTeamSwap,
      markets: e.markets,
      builderConfig: {
        ...e,
        selections: t.sort(Tn).map(
          (r) => ee({
            ...e,
            selection: r,
            isDisabled: r.isDisabled
          })
        )
      },
      groupSelections: In,
      mapToButton: (r) => re(r, {
        ...e,
        label: "",
        loadingSelectionIndex: e.loadingSelectionIndex,
        selectedSelectionIndex: e.selectedSelectionIndex,
        oddsStyle: e.oddsStyle
      }),
      mapToRowLabel: (r) => {
        var s, o;
        const n = (s = r.participants) == null ? void 0 : s[0];
        return K({
          id: r.id,
          isRowLabel: !0,
          label: r.label,
          textAlignModifier: "left",
          playerId: ie(n),
          participantType: n == null ? void 0 : n.type,
          seoIdentifier: n == null ? void 0 : n.seoIdentifier,
          statistic: ge(
            e.eventStatus,
            n == null ? void 0 : n.statistic,
            (o = e.featureFlags) == null ? void 0 : o["RLS-OSB-WEB-PlayerStatsEnabled"]
          )
        });
      },
      mapToEmptyButton: me,
      mapToHeaderLabel: (r) => K({
        id: `${r.marketName}`,
        isRowLabel: !1,
        label: `${r.marketName}`
      })
    })
  ];
}
function xs(e) {
  var t;
  return (t = e.featureFlags) != null && t["RLS-OSB-WEB-MilestonesComponentEnabled"] ? ne(e.markets).map((r, n) => {
    var u, b;
    const s = [...r.selections.values()].sort(te).map(
      (m) => it({
        ...e,
        selection: m,
        isDisabled: r.isSuspended
      })
    ), o = s[0];
    if (!o)
      return {
        key: r.id,
        templateName: "AutoGrid",
        columns: U.Columns_2_BigCells,
        cells: []
      };
    const i = $e(o), c = i.name || r.name, d = (i == null ? void 0 : i.type) === "Player";
    return {
      key: r.id,
      templateName: "AutoGrid",
      columns: U.Columns_2_BigCells,
      cells: [
        K({
          id: r.id,
          isRowLabel: !0,
          label: c,
          textAlignModifier: "left",
          playerId: ie(i),
          participantType: i == null ? void 0 : i.type,
          seoIdentifier: i == null ? void 0 : i.seoIdentifier,
          statistic: _e({
            eventStatus: e.eventStatus,
            statistics: r.statistics,
            isPlayerScoresEnabled: (u = e.featureFlags) == null ? void 0 : u["RLS-OSB-WEB-PlayerScoresEnabled"],
            participantStatistic: i == null ? void 0 : i.statistic,
            isPlayerStatsEnabled: (b = e.featureFlags) == null ? void 0 : b["RLS-OSB-WEB-PlayerStatsEnabled"]
          })
        }),
        Bn({
          parsedSelections: s,
          oddsStyle: e.oddsStyle,
          isFirstMarket: n === 0,
          consumerPageName: e.consumerPageName,
          leagueId: r.leagueId,
          isPlayerMarket: d
        })
      ]
    };
  }) : ft(e);
}
const Cs = (e, t, r) => {
  const n = Math.max(...e.map(Number), ...t.map(Number)), s = Array.from({ length: n + 1 }, (c, d) => String(d)), o = s.map(
    (c) => e.includes(c) ? c : r
  ), i = s.map(
    (c) => t.includes(c) ? c : r
  );
  return [o, i];
};
function _r(e, t = !0, r = 10) {
  var n, s;
  return (s = (n = e.featureFlags) == null ? void 0 : n["RLS-OSB-WEB-DkSquareAndCorrectScoreMarkets"]) != null && s.isCorrectScoreAndDkSquaresEnabled ? e.markets.map((o, i) => {
    var _, k;
    const c = /* @__PURE__ */ new Set(), d = /* @__PURE__ */ new Set(), u = e.logos[o.leagueId], b = [...o.selections.values()].reduce(
      (h, g) => {
        const { scoreHome: x, scoreAway: E } = Q(
          g.metadata,
          {}
        ), [N, O] = Un(
          e.isTeamSwap,
          Q(x, ""),
          Q(E, "")
        ), j = `${N}:${O}`;
        return N && O && (c.add(N), d.add(O), h[j] = {
          ...it({
            ...e,
            selection: g,
            isDisabled: o.isSuspended
          }),
          metadata: {
            ...g.metadata,
            scoreHome: N,
            scoreAway: O
          },
          marketName: o.name,
          label: j
        }), h;
      },
      {}
    ), m = Array.from(c).sort((h, g) => Number(h) - Number(g)), p = Array.from(d).sort((h, g) => Number(h) - Number(g));
    let S = [m, p];
    t && (m.length !== p.length || r > Math.max(m.length, p.length)) && (S = Cs(m, p, ""));
    const v = e.participants.sort((h, g) => Q(h.sortOrder, 0) - Q(g.sortOrder, 0)).map((h, g) => {
      const x = Q(h.metadata, {});
      return {
        id: Q(h.id, ""),
        name: Q(x.shortName, h.name),
        logoUrl: hr(e.staticS3Host, u == null ? void 0 : u.Teams, h.name),
        scores: S[g],
        teamColor: Q(x.teamColor, "")
      };
    }), C = K({
      id: `name_label_${o.id}`,
      isRowLabel: !0,
      stretchColumn: !0,
      label: o.name,
      textAlignModifier: "left",
      playerId: "",
      participantType: "",
      seoIdentifier: ""
    });
    return {
      key: o.id,
      templateName: "AutoGrid",
      columns: "1-column",
      cells: [
        C,
        Hn({
          gridSize: r || S[0].length,
          parsedSelections: b,
          participants: v,
          oddsStyle: e.oddsStyle,
          consumerPageName: e.consumerPageName,
          showTable: t,
          isFirstMarket: i === 0,
          isMarketSuspended: Q(o.isSuspended, !1),
          isTooltipEnabled: (k = (_ = e.featureFlags) == null ? void 0 : _["RLS-OSB-WEB-DkSquareAndCorrectScoreMarkets"]) == null ? void 0 : k.isTooltipEnabled
        })
      ]
    };
  }) : vr(e);
}
function ws(e) {
  return _r({ ...e, columns: U.Columns_3 }, !1, 0);
}
const _s = {
  7: Gn,
  8: Jn,
  11: ts,
  12: ht,
  18: ys,
  29: ft,
  30: es,
  202: ls,
  203: ds,
  204: vr,
  205: Qn,
  210: is,
  212: cs,
  214: bs,
  231: rs,
  240: ps,
  250: _r,
  255: ws,
  310: vs,
  330: Zn,
  331: xs
}, Ka = (e) => {
  if (!e.markets.length)
    return [];
  try {
    return _s[e.componentId](e);
  } catch (t) {
    const r = `%cThere are missing properties in some of the selections for '${e.componentId}' component id
`;
    return console.error(r, "color: black; background-color: orange;", t), e.logError({
      statusCode: "MarketCellsBuilderError",
      description: t instanceof Error ? JSON.stringify({
        message: `${r} - ${t.message}`,
        stack: t.stack
      }) : JSON.stringify({
        componentId: e.componentId,
        error: t
      }),
      eventId: e.eventId,
      marketIds: JSON.stringify(e.markets.map((n) => n.id))
    }), [];
  }
};
function ks(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var tt = { exports: {} }, xe = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var qt;
function Ts() {
  if (qt) return xe;
  qt = 1;
  var e = A, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, s = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function i(c, d, u) {
    var b, m = {}, p = null, S = null;
    u !== void 0 && (p = "" + u), d.key !== void 0 && (p = "" + d.key), d.ref !== void 0 && (S = d.ref);
    for (b in d) n.call(d, b) && !o.hasOwnProperty(b) && (m[b] = d[b]);
    if (c && c.defaultProps) for (b in d = c.defaultProps, d) m[b] === void 0 && (m[b] = d[b]);
    return { $$typeof: t, type: c, key: p, ref: S, props: m, _owner: s.current };
  }
  return xe.Fragment = r, xe.jsx = i, xe.jsxs = i, xe;
}
var Ce = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Xt;
function Es() {
  return Xt || (Xt = 1, process.env.NODE_ENV !== "production" && function() {
    var e = A, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), c = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), b = Symbol.for("react.suspense_list"), m = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), S = Symbol.for("react.offscreen"), v = Symbol.iterator, C = "@@iterator";
    function _(l) {
      if (l === null || typeof l != "object")
        return null;
      var f = v && l[v] || l[C];
      return typeof f == "function" ? f : null;
    }
    var k = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function h(l) {
      {
        for (var f = arguments.length, y = new Array(f > 1 ? f - 1 : 0), T = 1; T < f; T++)
          y[T - 1] = arguments[T];
        g("error", l, y);
      }
    }
    function g(l, f, y) {
      {
        var T = k.ReactDebugCurrentFrame, M = T.getStackAddendum();
        M !== "" && (f += "%s", y = y.concat([M]));
        var B = y.map(function(I) {
          return String(I);
        });
        B.unshift("Warning: " + f), Function.prototype.apply.call(console[l], console, B);
      }
    }
    var x = !1, E = !1, N = !1, O = !1, j = !1, R;
    R = Symbol.for("react.module.reference");
    function P(l) {
      return !!(typeof l == "string" || typeof l == "function" || l === n || l === o || j || l === s || l === u || l === b || O || l === S || x || E || N || typeof l == "object" && l !== null && (l.$$typeof === p || l.$$typeof === m || l.$$typeof === i || l.$$typeof === c || l.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      l.$$typeof === R || l.getModuleId !== void 0));
    }
    function D(l, f, y) {
      var T = l.displayName;
      if (T)
        return T;
      var M = f.displayName || f.name || "";
      return M !== "" ? y + "(" + M + ")" : y;
    }
    function H(l) {
      return l.displayName || "Context";
    }
    function G(l) {
      if (l == null)
        return null;
      if (typeof l.tag == "number" && h("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof l == "function")
        return l.displayName || l.name || null;
      if (typeof l == "string")
        return l;
      switch (l) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case s:
          return "StrictMode";
        case u:
          return "Suspense";
        case b:
          return "SuspenseList";
      }
      if (typeof l == "object")
        switch (l.$$typeof) {
          case c:
            var f = l;
            return H(f) + ".Consumer";
          case i:
            var y = l;
            return H(y._context) + ".Provider";
          case d:
            return D(l, l.render, "ForwardRef");
          case m:
            var T = l.displayName || null;
            return T !== null ? T : G(l.type) || "Memo";
          case p: {
            var M = l, B = M._payload, I = M._init;
            try {
              return G(I(B));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var W = Object.assign, F = 0, X, Ge, xt, Ct, wt, _t, kt;
    function Tt() {
    }
    Tt.__reactDisabledLog = !0;
    function Br() {
      {
        if (F === 0) {
          X = console.log, Ge = console.info, xt = console.warn, Ct = console.error, wt = console.group, _t = console.groupCollapsed, kt = console.groupEnd;
          var l = {
            configurable: !0,
            enumerable: !0,
            value: Tt,
            writable: !0
          };
          Object.defineProperties(console, {
            info: l,
            log: l,
            warn: l,
            error: l,
            group: l,
            groupCollapsed: l,
            groupEnd: l
          });
        }
        F++;
      }
    }
    function Hr() {
      {
        if (F--, F === 0) {
          var l = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: W({}, l, {
              value: X
            }),
            info: W({}, l, {
              value: Ge
            }),
            warn: W({}, l, {
              value: xt
            }),
            error: W({}, l, {
              value: Ct
            }),
            group: W({}, l, {
              value: wt
            }),
            groupCollapsed: W({}, l, {
              value: _t
            }),
            groupEnd: W({}, l, {
              value: kt
            })
          });
        }
        F < 0 && h("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var We = k.ReactCurrentDispatcher, Ve;
    function ke(l, f, y) {
      {
        if (Ve === void 0)
          try {
            throw Error();
          } catch (M) {
            var T = M.stack.trim().match(/\n( *(at )?)/);
            Ve = T && T[1] || "";
          }
        return `
` + Ve + l;
      }
    }
    var Ue = !1, Te;
    {
      var Fr = typeof WeakMap == "function" ? WeakMap : Map;
      Te = new Fr();
    }
    function Et(l, f) {
      if (!l || Ue)
        return "";
      {
        var y = Te.get(l);
        if (y !== void 0)
          return y;
      }
      var T;
      Ue = !0;
      var M = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var B;
      B = We.current, We.current = null, Br();
      try {
        if (f) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (Z) {
              T = Z;
            }
            Reflect.construct(l, [], I);
          } else {
            try {
              I.call();
            } catch (Z) {
              T = Z;
            }
            l.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Z) {
            T = Z;
          }
          l();
        }
      } catch (Z) {
        if (Z && T && typeof Z.stack == "string") {
          for (var L = Z.stack.split(`
`), J = T.stack.split(`
`), V = L.length - 1, z = J.length - 1; V >= 1 && z >= 0 && L[V] !== J[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (L[V] !== J[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || L[V] !== J[z]) {
                    var se = `
` + L[V].replace(" at new ", " at ");
                    return l.displayName && se.includes("<anonymous>") && (se = se.replace("<anonymous>", l.displayName)), typeof l == "function" && Te.set(l, se), se;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Ue = !1, We.current = B, Hr(), Error.prepareStackTrace = M;
      }
      var fe = l ? l.displayName || l.name : "", de = fe ? ke(fe) : "";
      return typeof l == "function" && Te.set(l, de), de;
    }
    function Gr(l, f, y) {
      return Et(l, !1);
    }
    function Wr(l) {
      var f = l.prototype;
      return !!(f && f.isReactComponent);
    }
    function Ee(l, f, y) {
      if (l == null)
        return "";
      if (typeof l == "function")
        return Et(l, Wr(l));
      if (typeof l == "string")
        return ke(l);
      switch (l) {
        case u:
          return ke("Suspense");
        case b:
          return ke("SuspenseList");
      }
      if (typeof l == "object")
        switch (l.$$typeof) {
          case d:
            return Gr(l.render);
          case m:
            return Ee(l.type, f, y);
          case p: {
            var T = l, M = T._payload, B = T._init;
            try {
              return Ee(B(M), f, y);
            } catch {
            }
          }
        }
      return "";
    }
    var ve = Object.prototype.hasOwnProperty, Nt = {}, Ot = k.ReactDebugCurrentFrame;
    function Ne(l) {
      if (l) {
        var f = l._owner, y = Ee(l.type, l._source, f ? f.type : null);
        Ot.setExtraStackFrame(y);
      } else
        Ot.setExtraStackFrame(null);
    }
    function Vr(l, f, y, T, M) {
      {
        var B = Function.call.bind(ve);
        for (var I in l)
          if (B(l, I)) {
            var L = void 0;
            try {
              if (typeof l[I] != "function") {
                var J = Error((T || "React class") + ": " + y + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof l[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw J.name = "Invariant Violation", J;
              }
              L = l[I](f, I, T, y, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              L = V;
            }
            L && !(L instanceof Error) && (Ne(M), h("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", T || "React class", y, I, typeof L), Ne(null)), L instanceof Error && !(L.message in Nt) && (Nt[L.message] = !0, Ne(M), h("Failed %s type: %s", y, L.message), Ne(null));
          }
      }
    }
    var Ur = Array.isArray;
    function ze(l) {
      return Ur(l);
    }
    function zr(l) {
      {
        var f = typeof Symbol == "function" && Symbol.toStringTag, y = f && l[Symbol.toStringTag] || l.constructor.name || "Object";
        return y;
      }
    }
    function Yr(l) {
      try {
        return jt(l), !1;
      } catch {
        return !0;
      }
    }
    function jt(l) {
      return "" + l;
    }
    function Lt(l) {
      if (Yr(l))
        return h("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", zr(l)), jt(l);
    }
    var ye = k.ReactCurrentOwner, Kr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, It, Rt, Ye;
    Ye = {};
    function qr(l) {
      if (ve.call(l, "ref")) {
        var f = Object.getOwnPropertyDescriptor(l, "ref").get;
        if (f && f.isReactWarning)
          return !1;
      }
      return l.ref !== void 0;
    }
    function Xr(l) {
      if (ve.call(l, "key")) {
        var f = Object.getOwnPropertyDescriptor(l, "key").get;
        if (f && f.isReactWarning)
          return !1;
      }
      return l.key !== void 0;
    }
    function Jr(l, f) {
      if (typeof l.ref == "string" && ye.current && f && ye.current.stateNode !== f) {
        var y = G(ye.current.type);
        Ye[y] || (h('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', G(ye.current.type), l.ref), Ye[y] = !0);
      }
    }
    function Zr(l, f) {
      {
        var y = function() {
          It || (It = !0, h("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", f));
        };
        y.isReactWarning = !0, Object.defineProperty(l, "key", {
          get: y,
          configurable: !0
        });
      }
    }
    function Qr(l, f) {
      {
        var y = function() {
          Rt || (Rt = !0, h("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", f));
        };
        y.isReactWarning = !0, Object.defineProperty(l, "ref", {
          get: y,
          configurable: !0
        });
      }
    }
    var en = function(l, f, y, T, M, B, I) {
      var L = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: l,
        key: f,
        ref: y,
        props: I,
        // Record the component responsible for creating this element.
        _owner: B
      };
      return L._store = {}, Object.defineProperty(L._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(L, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: T
      }), Object.defineProperty(L, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: M
      }), Object.freeze && (Object.freeze(L.props), Object.freeze(L)), L;
    };
    function tn(l, f, y, T, M) {
      {
        var B, I = {}, L = null, J = null;
        y !== void 0 && (Lt(y), L = "" + y), Xr(f) && (Lt(f.key), L = "" + f.key), qr(f) && (J = f.ref, Jr(f, M));
        for (B in f)
          ve.call(f, B) && !Kr.hasOwnProperty(B) && (I[B] = f[B]);
        if (l && l.defaultProps) {
          var V = l.defaultProps;
          for (B in V)
            I[B] === void 0 && (I[B] = V[B]);
        }
        if (L || J) {
          var z = typeof l == "function" ? l.displayName || l.name || "Unknown" : l;
          L && Zr(I, z), J && Qr(I, z);
        }
        return en(l, L, J, M, T, ye.current, I);
      }
    }
    var Ke = k.ReactCurrentOwner, Mt = k.ReactDebugCurrentFrame;
    function be(l) {
      if (l) {
        var f = l._owner, y = Ee(l.type, l._source, f ? f.type : null);
        Mt.setExtraStackFrame(y);
      } else
        Mt.setExtraStackFrame(null);
    }
    var qe;
    qe = !1;
    function Xe(l) {
      return typeof l == "object" && l !== null && l.$$typeof === t;
    }
    function Pt() {
      {
        if (Ke.current) {
          var l = G(Ke.current.type);
          if (l)
            return `

Check the render method of \`` + l + "`.";
        }
        return "";
      }
    }
    function rn(l) {
      return "";
    }
    var At = {};
    function nn(l) {
      {
        var f = Pt();
        if (!f) {
          var y = typeof l == "string" ? l : l.displayName || l.name;
          y && (f = `

Check the top-level render call using <` + y + ">.");
        }
        return f;
      }
    }
    function $t(l, f) {
      {
        if (!l._store || l._store.validated || l.key != null)
          return;
        l._store.validated = !0;
        var y = nn(f);
        if (At[y])
          return;
        At[y] = !0;
        var T = "";
        l && l._owner && l._owner !== Ke.current && (T = " It was passed a child from " + G(l._owner.type) + "."), be(l), h('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', y, T), be(null);
      }
    }
    function Dt(l, f) {
      {
        if (typeof l != "object")
          return;
        if (ze(l))
          for (var y = 0; y < l.length; y++) {
            var T = l[y];
            Xe(T) && $t(T, f);
          }
        else if (Xe(l))
          l._store && (l._store.validated = !0);
        else if (l) {
          var M = _(l);
          if (typeof M == "function" && M !== l.entries)
            for (var B = M.call(l), I; !(I = B.next()).done; )
              Xe(I.value) && $t(I.value, f);
        }
      }
    }
    function sn(l) {
      {
        var f = l.type;
        if (f == null || typeof f == "string")
          return;
        var y;
        if (typeof f == "function")
          y = f.propTypes;
        else if (typeof f == "object" && (f.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        f.$$typeof === m))
          y = f.propTypes;
        else
          return;
        if (y) {
          var T = G(f);
          Vr(y, l.props, "prop", T, l);
        } else if (f.PropTypes !== void 0 && !qe) {
          qe = !0;
          var M = G(f);
          h("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", M || "Unknown");
        }
        typeof f.getDefaultProps == "function" && !f.getDefaultProps.isReactClassApproved && h("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function an(l) {
      {
        for (var f = Object.keys(l.props), y = 0; y < f.length; y++) {
          var T = f[y];
          if (T !== "children" && T !== "key") {
            be(l), h("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", T), be(null);
            break;
          }
        }
        l.ref !== null && (be(l), h("Invalid attribute `ref` supplied to `React.Fragment`."), be(null));
      }
    }
    var Bt = {};
    function Ht(l, f, y, T, M, B) {
      {
        var I = P(l);
        if (!I) {
          var L = "";
          (l === void 0 || typeof l == "object" && l !== null && Object.keys(l).length === 0) && (L += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var J = rn();
          J ? L += J : L += Pt();
          var V;
          l === null ? V = "null" : ze(l) ? V = "array" : l !== void 0 && l.$$typeof === t ? (V = "<" + (G(l.type) || "Unknown") + " />", L = " Did you accidentally export a JSX literal instead of a component?") : V = typeof l, h("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, L);
        }
        var z = tn(l, f, y, M, B);
        if (z == null)
          return z;
        if (I) {
          var se = f.children;
          if (se !== void 0)
            if (T)
              if (ze(se)) {
                for (var fe = 0; fe < se.length; fe++)
                  Dt(se[fe], l);
                Object.freeze && Object.freeze(se);
              } else
                h("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Dt(se, l);
        }
        if (ve.call(f, "key")) {
          var de = G(l), Z = Object.keys(f).filter(function(mn) {
            return mn !== "key";
          }), Je = Z.length > 0 ? "{key: someKey, " + Z.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Bt[de + Je]) {
            var un = Z.length > 0 ? "{" + Z.join(": ..., ") + ": ...}" : "{}";
            h(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Je, de, un, de), Bt[de + Je] = !0;
          }
        }
        return l === n ? an(z) : sn(z), z;
      }
    }
    function on(l, f, y) {
      return Ht(l, f, y, !0);
    }
    function ln(l, f, y) {
      return Ht(l, f, y, !1);
    }
    var cn = ln, dn = on;
    Ce.Fragment = n, Ce.jsx = cn, Ce.jsxs = dn;
  }()), Ce;
}
process.env.NODE_ENV === "production" ? tt.exports = Ts() : tt.exports = Es();
var a = tt.exports, kr = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function r() {
      for (var o = "", i = 0; i < arguments.length; i++) {
        var c = arguments[i];
        c && (o = s(o, n(c)));
      }
      return o;
    }
    function n(o) {
      if (typeof o == "string" || typeof o == "number")
        return o;
      if (typeof o != "object")
        return "";
      if (Array.isArray(o))
        return r.apply(null, o);
      if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]"))
        return o.toString();
      var i = "";
      for (var c in o)
        t.call(o, c) && o[c] && (i = s(i, c));
      return i;
    }
    function s(o, i) {
      return i ? o ? o + " " + i : o + i : o;
    }
    e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
  })();
})(kr);
var Ns = kr.exports;
const $ = /* @__PURE__ */ ks(Ns), ae = "cb-market", Tr = {
  button: `${ae}__button`,
  label: `${ae}__label`,
  labelName: `${ae}__label-name`,
  template: `${ae}__template`,
  header: `${ae}__header`,
  category: `${ae}s-category`,
  subcategory: `${ae}s-subcategory`,
  subcategories: `${ae}s-subcategories`,
  arrow: `${ae}__groups-arrow`,
  collapsible: `${ae}-collapsible`,
  expandable: `${ae}-button-expandable`,
  lazyRenderContainer: `${ae}__lazy-render-container`
};
Object.freeze(Tr);
function le(e) {
  return Tr[e];
}
const De = w.createContext({});
De.displayName = "SubCategoryLazyRenderContext";
class Er {
  constructor(t, r) {
    oe(this, "callback");
    oe(this, "rootMargin");
    oe(this, "root");
    oe(this, "thresholds");
    oe(this, "faked");
    const n = r.threshold && Array.isArray(r.threshold) ? r.threshold : [r.threshold || 0.01];
    this.faked = !0, this.thresholds = n, this.callback = t, this.root = r.root || null, this.rootMargin = r.rootMargin || "";
  }
  disconnect() {
  }
  observe() {
    this.callback(this.takeRecords(), {});
  }
  takeRecords() {
    return [
      {
        isIntersecting: !0,
        target: null
      }
    ];
  }
  unobserve() {
  }
}
function Nr() {
  return typeof IntersectionObserver < "u" ? IntersectionObserver : Er;
}
const Os = (e, t) => {
  const r = A.Children.toArray(t), n = A.Children.toArray(e);
  return r.some((s, o) => s.key !== n[o].key);
};
function Re(e, t, r) {
  const { duration: n, start: s, end: o } = t;
  e.animate([{ transform: `translateX(${s}px)` }, { transform: `translateX(${o}px)` }], {
    duration: n,
    easing: "ease-out",
    fill: "forwards",
    iterations: 1
  }), r && r();
}
const gt = () => {
  let e = () => {
  }, t = () => {
  };
  if (typeof window < "u") {
    const r = (n) => {
      n.preventDefault();
    };
    e = () => {
      window.addEventListener("DOMMouseScroll", r, !1), window.addEventListener("wheel", r, { passive: !1 });
    }, t = () => {
      window.removeEventListener("DOMMouseScroll", r, !1), window.removeEventListener("wheel", r, { passive: !1 });
    };
  }
  return {
    disableScroll: e,
    enableScroll: t
  };
}, ce = (e) => {
  const t = ue();
  return pe(() => {
    t.current = e;
  }, [e]), t.current;
};
function js(e, t, r) {
  var n = r || {}, s = n.noTrailing, o = s === void 0 ? !1 : s, i = n.noLeading, c = i === void 0 ? !1 : i, d = n.debounceMode, u = d === void 0 ? void 0 : d, b, m = !1, p = 0;
  function S() {
    b && clearTimeout(b);
  }
  function v(_) {
    var k = _ || {}, h = k.upcomingOnly, g = h === void 0 ? !1 : h;
    S(), m = !g;
  }
  function C() {
    for (var _ = arguments.length, k = new Array(_), h = 0; h < _; h++)
      k[h] = arguments[h];
    var g = this, x = Date.now() - p;
    if (m)
      return;
    function E() {
      p = Date.now(), t.apply(g, k);
    }
    function N() {
      b = void 0;
    }
    !c && u && !b && E(), S(), u === void 0 && x > e ? c ? (p = Date.now(), o || (b = setTimeout(u ? N : E, e))) : E() : o !== !0 && (b = setTimeout(u ? N : E, u === void 0 ? e - x : e));
  }
  return C.cancel = v, C;
}
const vt = (e, t, r) => js(
  100,
  (n) => {
    if (r)
      return;
    const s = n.deltaY, o = Math.sign(s);
    o > 0 ? e() : o < 0 && t();
  },
  { noLeading: !0 }
), Ls = w.memo(function({
  title: t,
  rightSide: r = null
}) {
  return /* @__PURE__ */ a.jsxs("h2", { className: "cb-collapsible-header", "data-testid": "collapsible-header", children: [
    t,
    r
  ] });
}), Is = ({ isExpanded: e }) => {
  const t = "cb-collapsible", r = e ? "up" : "down";
  return /* @__PURE__ */ a.jsx("div", { className: `${t}-arrow-wrapper`, children: /* @__PURE__ */ a.jsx("div", { className: `${t}-arrow`, children: /* @__PURE__ */ a.jsx(
    "svg",
    {
      role: "img",
      className: $(
        `${t}-arrow-inner__${r}`,
        `${t}-arrow-inner`
      ),
      viewBox: "0 0 32 32",
      children: /* @__PURE__ */ a.jsx("path", { d: "M16.032 6.144h-0.032l-14.624 14.656c-0.384 0.384-0.384 0.992 0 1.344l1.504 1.504c0.384 0.384 0.992 0.384 1.344 0l11.776-11.776h0.032l11.776 11.776c0.384 0.384 0.992 0.384 1.344 0l1.504-1.504c0.384-0.384 0.384-0.992 0-1.344l-14.624-14.656z" })
    }
  ) }) });
}, Rs = w.memo(function(t) {
  return /* @__PURE__ */ a.jsxs(
    "button",
    {
      type: "button",
      className: "cb-collapsible-trigger",
      onClick: t.onClick,
      "data-testid": "collapsible-trigger",
      children: [
        /* @__PURE__ */ a.jsxs("span", { className: "cb-collapsible-trigger__content", children: [
          /* @__PURE__ */ a.jsx(Ls, { ...t.headerData }),
          t.badge
        ] }),
        /* @__PURE__ */ a.jsx(Is, { isExpanded: t.isExpanded })
      ]
    }
  );
}), Or = fn(void 0), Ms = ({ children: e }) => {
  const [t, r] = we(0);
  return /* @__PURE__ */ a.jsx(Or.Provider, { value: { additionalHeight: t, setAdditionalHeight: r }, children: e });
}, Be = () => {
  const e = cr(Or);
  if (e === void 0)
    throw new Error("useAdditionalHeight must be used within a CollapsedMarketHeightContextProvider");
  return e;
}, Ps = (e) => (t) => /* @__PURE__ */ a.jsx(Ms, { children: /* @__PURE__ */ a.jsx(e, { ...t }) }), As = ({
  contentId: e,
  isExpanded: t,
  trigger: r,
  content: n,
  onToggleExpandClick: s,
  animationConfig: o
}) => {
  const i = "cb-collapsible", c = ue(null), [d, u] = we(t ? "auto" : 0), { additionalHeight: b } = Be();
  dr(() => {
    let p = window.innerWidth;
    const S = () => {
      t && c.current !== null ? u(b + c.current.scrollHeight) : u(0);
    };
    S();
    const v = () => {
      const C = window.innerWidth;
      C !== p && (S(), p = C);
    };
    return window.addEventListener("resize", v), () => {
      window.removeEventListener("resize", v);
    };
  }, [t, b, n]);
  const m = () => {
    s(e);
  };
  return /* @__PURE__ */ a.jsxs("div", { className: i, "data-collapsed": !t, "data-testid": "collapsible-wrapper", children: [
    /* @__PURE__ */ a.jsx(
      Rs,
      {
        headerData: r.data,
        badge: r.badge,
        isExpanded: t,
        onClick: m
      }
    ),
    /* @__PURE__ */ a.jsx(
      "div",
      {
        className: `${i}__content`,
        style: {
          maxHeight: t ? d !== "auto" ? `${b + d}px` : d : 0,
          overflow: "hidden",
          transition: `max-height ${o.duration}ms ${o.ease}`
        },
        ref: c,
        children: /* @__PURE__ */ a.jsx("div", { className: `${i}__content-inner`, children: n })
      }
    )
  ] });
}, $s = Ps(As), qa = (e) => {
  const t = e.marketData.marketsCells.reduce((s, o) => s + o.cells.length, 0), r = ue(t), n = cr(De);
  return dr(() => {
    const s = e.marketData.marketsCells.reduce(
      (o, i) => o + i.cells.length,
      0
    );
    r.current !== s && n.setHeight(), r.current = s;
  }, [t, n, e.marketData.marketsCells]), /* @__PURE__ */ a.jsx(
    "div",
    {
      className: $("cb-subcategory", {
        [`subcategory--${e.marketData.marketsCells[0].templateModifier}`]: e.marketData.marketsCells[0].templateModifier
      }),
      "data-testid": "component-builder-market",
      children: /* @__PURE__ */ a.jsx(
        $s,
        {
          trigger: e.trigger,
          content: e.marketData.marketsCells.map((s) => /* @__PURE__ */ at(
            Wa,
            {
              consumerVersion: e.marketData.consumerVersion,
              widgetVersion: e.marketData.widgetVersion,
              ...s,
              key: `market-${s.key}`,
              productConfig: e.marketData.productConfig,
              trackEvent: e.marketData.trackEvent,
              playerPageConfig: e.marketData.playerPageConfig,
              getPlayerLink: e.marketData.getPlayerLink,
              onPlayerLinkClick: e.marketData.onPlayerLinkClick,
              marketboardRef: e.marketData.marketboardRef,
              getTeamLogo: e.marketData.getTeamLogo
            }
          )),
          isExpanded: e.isExpanded,
          contentId: e.contentId,
          contentType: "subcategory",
          onToggleExpandClick: e.onToggleExpandClick,
          animationConfig: e.animationConfig
        }
      )
    }
  );
}, Xa = w.memo(function(t) {
  const { category: r, children: n } = t, s = le("category");
  return /* @__PURE__ */ a.jsxs("div", { className: s, children: [
    /* @__PURE__ */ a.jsx("p", { className: `${s}__name`, children: r.name }),
    /* @__PURE__ */ a.jsx("div", { className: `${s}__content`, children: n })
  ] });
}), Ds = {
  // root: null,
  rootMargin: "0px",
  threshold: 0.01
};
class Bs {
  constructor(t) {
    oe(this, "isVisible");
    oe(this, "observer");
    oe(this, "idleCallbackID");
    oe(this, "isProgressiveMode");
    const r = Nr();
    this.observer = new r(this.updateOnIdle.bind(this), { ...Ds, ...t }), this.isVisible = this.observer instanceof Er, this.isProgressiveMode = t.lazyRenderMode === "progressive", this.idleCallbackID = 0, Sn(this, {
      isVisible: gn,
      updateVisibility: vn
    });
  }
  registerDom(t) {
    this.observer.observe(t);
  }
  unRegisterDom(t) {
    this.observer.unobserve(t);
  }
  updateOnIdle(t) {
    window.cancelAnimationFrame(this.idleCallbackID), this.idleCallbackID = window.requestAnimationFrame(this.updateVisibility.bind(this, t));
  }
  updateVisibility(t) {
    (this.isProgressiveMode && !this.isVisible || !this.isProgressiveMode) && (this.isVisible = t[0].isIntersecting);
  }
}
const Hs = hn((e) => {
  const t = w.useRef(null), r = w.useRef(
    new Bs({
      ...e.observerOptions,
      lazyRenderMode: e.lazyRenderMode
    })
  ), n = r.current.isVisible;
  w.useEffect(() => {
    const o = r.current, i = t.current;
    return i && o.registerDom(i), () => {
      i && o.unRegisterDom(i);
    };
  }, []);
  const s = () => typeof e.contentCallback == "function" && n ? e.contentCallback() : e.children;
  return /* @__PURE__ */ a.jsx(
    "div",
    {
      className: "cb-lazy-render",
      style: { minHeight: n ? "auto" : e.baseMinHeight },
      ref: t,
      "data-testid": "sb-lazy-render",
      children: n && s()
    }
  );
}), Fs = ({
  forwardedRef: e,
  children: t
}) => {
  const r = le("lazyRenderContainer"), { setHeight: n } = w.useContext(De), s = w.useRef(null);
  return w.useLayoutEffect(() => {
    (s.current === null || w.Children.count(t) !== w.Children.count(s.current) || Os(t, s.current)) && (n == null || n()), s.current = t;
  }, [t, n]), /* @__PURE__ */ a.jsx("div", { ref: e, className: r, "data-testid": "subcategory-lazy-render-container", children: t });
}, Gs = w.forwardRef(({ children: e }, t) => /* @__PURE__ */ a.jsx(Fs, { forwardedRef: t, children: e })), Ja = (e) => {
  const t = w.useRef(null), [r, n] = w.useState(e.marketsLength * e.marketMinHeight), s = () => {
    t.current && n(t.current.offsetHeight);
  }, o = (i) => {
    n((c) => c + i);
  };
  return /* @__PURE__ */ a.jsx(
    De.Provider,
    {
      value: {
        setHeight: s,
        adjustHeight: o
      },
      children: /* @__PURE__ */ a.jsx(
        Hs,
        {
          baseMinHeight: r,
          observerOptions: e.observerOptions,
          lazyRenderMode: e.lazyRenderMode,
          children: /* @__PURE__ */ a.jsx(Gs, { ref: t, children: e.children })
        }
      )
    }
  );
}, Le = ({
  dualGridModifier: e,
  fixedGridModifier: t,
  columns: r,
  children: n
}) => {
  const s = le("template");
  return /* @__PURE__ */ a.jsx(
    "div",
    {
      "data-testid": "market-template",
      className: $(
        s,
        `${s}--${r}`,
        { [`${s}--${e}`]: e },
        { [`${s}--${t}`]: t }
      ),
      children: n
    }
  );
};
class Ws extends w.Component {
  constructor(t) {
    super(t), this.state = {
      hasError: !1
    };
  }
  componentDidCatch() {
    this.setState({
      hasError: !0
    });
  }
  render() {
    return this.state.hasError ? null : this.props.children;
  }
}
const Me = ({
  oddsStyle: e = "american",
  colorOverride: t = !1,
  noMargin: r = !1,
  displayOdds: n
}) => {
  if (!n)
    return null;
  let s = n.decimal;
  return e === "american" && n.american ? s = n.american : e === "fractional" && n.fractional && (s = n.fractional), s || (n.american ? s = n.american : n.fractional && (s = n.fractional)), /* @__PURE__ */ a.jsx("span", { className: `cb-odds ${r ? "no-margin" : ""} ${t ? "" : "default-color"}`, children: s });
}, Vs = (e) => e === "Over" || e === "Under" || e === "Exactly", Jt = (e, t) => t && e > 0 ? `+${e}` : e.toString(), Zt = (e, t) => {
  const r = !Vs(t);
  if (typeof e == "number")
    return Jt(e, r);
  {
    const n = Number(e);
    return Jt(n, r);
  }
}, Us = (e, t) => e.offsetWidth / 2 - t.offsetLeft - t.offsetWidth / 2;
function Y(e, t) {
  const { start: r, end: n } = t;
  e.animate([{ transform: `translateY(${r}%)` }, { transform: `translateY(${n}%)` }], {
    duration: 300,
    fill: "forwards",
    easing: "ease-out",
    iterations: 1
  });
}
const zs = (e, t) => e.reduce((r, n) => {
  var s;
  return (r[s = t(n)] || (r[s] = [])).push(n), r;
}, {}), Qt = (e) => {
  const {
    selectedLineIndex: t,
    isDisabled: r,
    isSelected: n,
    displayOdds: s = {},
    label: o,
    points: i,
    oddsStyle: c,
    selectionHandlerIDs: d,
    isLoading: u,
    onSelectionClick: b
  } = e, m = n || r || u, { decimal: p } = s, [S, v] = w.useState(""), [C, _] = w.useState(i), [k, h] = w.useState(void 0), [g, x] = w.useState(s), E = ce(t), N = w.useRef(null), O = w.useRef(null), j = w.useRef(null), R = w.useRef(null), P = w.useRef(null), D = () => {
    O.current && j.current && (Y(O.current, { start: 0, end: -100 }), Y(j.current, { start: 100, end: 0 })), R.current && P.current && (Y(R.current, { start: 0, end: -100 }), Y(P.current, { start: 100, end: 0 }));
  }, H = () => {
    O.current && j.current && (Y(O.current, { start: 0, end: 100 }), Y(j.current, { start: -100, end: 0 })), R.current && P.current && (Y(R.current, { start: 0, end: 100 }), Y(P.current, { start: -100, end: 0 }));
  };
  q(() => {
    E !== void 0 && (v(C), _(i), h(g), x(s), t > E ? D() : H());
  }, [t]), q(() => {
    if (N.current && t === E) {
      const W = getComputedStyle(N.current).getPropertyValue("--background-color"), F = getComputedStyle(N.current).getPropertyValue("--background-color-flash");
      N.current.animate(
        [{ backgroundColor: W }, { backgroundColor: F }, { backgroundColor: W }],
        {
          duration: 600,
          easing: "ease-in-out",
          iterations: 1
        }
      );
    }
    h(s), x(s);
  }, [p]), q(() => {
    t === E && (v(i), _(i));
  }, [i]);
  const G = (W) => {
    W.stopPropagation(), !r && d && b && b(d);
  };
  return /* @__PURE__ */ a.jsxs(
    "div",
    {
      "aria-pressed": n,
      ref: N,
      className: $("cb-line-cell", { selected: n }, { disabled: r }, { loading: u }),
      "data-testid": "line-cell",
      onClick: G,
      children: [
        u && /* @__PURE__ */ a.jsx("div", { className: "cb-line-cell__animate-loading" }),
        /* @__PURE__ */ a.jsxs("div", { className: "cb-line-cell__left-data", children: [
          /* @__PURE__ */ a.jsx("div", { className: "cb-line-cell__label", children: o }),
          /* @__PURE__ */ a.jsxs("div", { className: "cb-line-cell__odds", children: [
            /* @__PURE__ */ a.jsx("div", { className: "cb-line-cell__odds-prev", ref: R, children: /* @__PURE__ */ a.jsx(Me, { noMargin: !0, colorOverride: m, oddsStyle: c, displayOdds: k }) }),
            /* @__PURE__ */ a.jsx("div", { className: "cb-line-cell__odds-curr", ref: P, children: /* @__PURE__ */ a.jsx(Me, { noMargin: !0, colorOverride: m, oddsStyle: c, displayOdds: g }) })
          ] })
        ] }),
        /* @__PURE__ */ a.jsxs("div", { className: "cb-line-cell__line", children: [
          /* @__PURE__ */ a.jsx("div", { className: "cb-line-cell__line-prev", ref: O, "data-testid": "prev-line-value", children: Zt(S, o) }),
          /* @__PURE__ */ a.jsx("div", { className: "cb-line-cell__line-curr", ref: j, "data-testid": "curr-line-value", children: Zt(C, o) })
        ] })
      ]
    }
  );
}, { enableScroll: er, disableScroll: Ys } = gt(), Ks = (e) => {
  const { lines: t, selectedLineIndex: r, onSelectLine: n } = e, s = t[0].isDisabled, o = fr(), i = w.useRef(null), c = w.useRef(null), [d, u] = w.useState(0), b = ce(r), m = () => o(() => {
    if (i.current && c.current) {
      const h = i.current.querySelector(
        ".cb-line-picker__line.selected"
      );
      if (h) {
        const g = Us(i.current, h);
        Re(c.current, { duration: 0, start: d, end: g }), u(g);
      }
    }
  }, 25), p = () => !s && Ys(), S = () => er(), v = () => {
    const h = t[r - 1];
    h && n(h.id);
  }, C = () => {
    const h = t[r + 1];
    h && n(h.id);
  }, _ = vt(C, v, s);
  q(() => (m(), window.addEventListener("resize", m), () => {
    window.removeEventListener("resize", m), _.cancel(), er();
  }), []);
  const k = (h) => {
    const g = t[h];
    g && n(g.id);
  };
  return q(() => {
    if (b === void 0 || !c.current)
      return;
    const h = Math.abs(b - r), g = h * 40;
    let x = d;
    r > b ? x -= g : r < b && (x += g), Re(c.current, { duration: h > 2 ? 600 : 300, start: d, end: x }), u(x);
  }, [r]), /* @__PURE__ */ a.jsxs(
    "div",
    {
      onWheel: _,
      onMouseEnter: p,
      onMouseLeave: S,
      className: $("cb-line-picker", { disabled: s }),
      "data-testid": "line-picker",
      children: [
        /* @__PURE__ */ a.jsx("div", { className: "cb-line-picker__left-arrow", onClick: v, children: /* @__PURE__ */ a.jsx(
          "svg",
          {
            role: "img",
            "aria-label": "Arrow pointing left icon",
            className: "cb-icon--arrow-left",
            fill: "#ababab",
            width: "20",
            height: "20",
            viewBox: "0 0 32 32",
            children: /* @__PURE__ */ a.jsx("path", { d: "M5.504 15.968v0.032l14.656 14.624c0.384 0.384 0.992 0.384 1.344 0l1.504-1.504c0.384-0.384 0.384-0.992 0-1.344l-11.776-11.744v-0.032l11.776-11.776c0.384-0.384 0.384-0.992 0-1.344l-1.504-1.504c-0.384-0.384-0.992-0.384-1.344 0l-14.656 14.592z" })
          }
        ) }),
        /* @__PURE__ */ a.jsxs("div", { ref: i, className: "cb-line-picker__lines-wrapper", children: [
          /* @__PURE__ */ a.jsx("div", { className: "cb-line-picker__line-glow" }),
          /* @__PURE__ */ a.jsx("div", { ref: c, className: "cb-line-picker__lines-animation", children: t.map((h, g) => {
            var x;
            return /* @__PURE__ */ a.jsx(
              "div",
              {
                onClick: () => k(g),
                className: $(
                  "cb-line-picker__line",
                  { selected: g === r },
                  { main: (x = h == null ? void 0 : h.tags) == null ? void 0 : x.includes("MainPointLine") }
                ),
                children: Math.abs(Number(h.points))
              },
              h.id
            );
          }) })
        ] }),
        /* @__PURE__ */ a.jsx("div", { className: "cb-line-picker__right-arrow", onClick: C, children: /* @__PURE__ */ a.jsx(
          "svg",
          {
            role: "img",
            "aria-label": "Arrow pointing right icon",
            className: "cb-icon--arrow-right",
            fill: "#ababab",
            width: "20",
            height: "20",
            viewBox: "0 0 32 32",
            children: /* @__PURE__ */ a.jsx("path", { d: "M26.464 16.032v-0.032l-14.624-14.624c-0.384-0.384-0.992-0.384-1.344 0l-1.504 1.504c-0.384 0.384-0.384 0.992 0 1.344l11.776 11.776v0.032l-11.776 11.744c-0.384 0.384-0.384 0.992 0 1.344l1.504 1.504c0.384 0.384 0.992 0.384 1.344 0l14.624-14.592z" })
          }
        ) })
      ]
    }
  );
}, tr = 300, Ze = [...Array(10).keys()], qs = ({ digit: e }) => {
  const [t, r] = A.useState(e), n = ce(t), s = A.useRef(null), o = A.useRef(), i = A.useRef(), c = typeof n < "u" ? Math.abs(e - n) : 0, d = c ? Math.floor(tr / c) : tr, u = (m) => {
    var p;
    (p = s.current) == null || p.style.setProperty("transition-duration", `${d}ms`), r(Ze[m]);
  };
  q(() => {
    if (typeof n > "u" || e === n)
      return;
    const m = e > n ? 1 : -1;
    let p = Ze.indexOf(n) + m;
    if (u(p), c <= 1)
      return;
    const S = (v) => {
      if (i.current || (i.current = v), v - i.current >= d && (p += m, u(p), i.current = v, p === e)) {
        o.current && cancelAnimationFrame(o.current);
        return;
      }
      o.current = requestAnimationFrame(S);
    };
    return o.current = requestAnimationFrame(S), () => {
      o.current && cancelAnimationFrame(o.current);
    };
  }, [e]);
  const b = (m) => `translateY(${(m - t) * 100}%)`;
  return /* @__PURE__ */ a.jsx("div", { className: "cb-player-stats__digits-wrapper", ref: s, children: Ze.map((m) => /* @__PURE__ */ a.jsx(
    "div",
    {
      className: $("cb-player-stats__digit", { active: m === t }),
      style: { transform: b(m) },
      "data-testid": `digit-${m}`,
      children: m
    },
    m
  )) });
}, Xs = A.memo(function({ value: t }) {
  const r = t.toString().split("");
  return /* @__PURE__ */ a.jsx("div", { className: "cb-player-stats__highlight", children: r.map((n, s) => {
    const o = Number(n);
    return Number.isNaN(o) ? /* @__PURE__ */ a.jsx("span", { children: n }, s) : /* @__PURE__ */ a.jsx(qs, { digit: o }, s);
  }) }, r.length);
}), jr = ({
  children: e,
  statistic: t,
  hasPlayerImages: r = !1
}) => t ? /* @__PURE__ */ a.jsxs("div", { className: $("cb-player-stats-wrapper", { "with-player-image": r }), children: [
  e,
  /* @__PURE__ */ a.jsxs("div", { className: "cb-player-stats", "data-testid": "player-stats", children: [
    /* @__PURE__ */ a.jsxs("div", { className: "cb-player-stats__prefix", children: [
      t.prefix,
      ": "
    ] }),
    /* @__PURE__ */ a.jsx(Xs, { value: t.value })
  ] })
] }) : /* @__PURE__ */ a.jsx(a.Fragment, { children: e }), Js = (e) => e == null ? void 0 : e.some((t) => typeof t == "string" && t.length > 1), Zs = (e) => {
  var O, j, R;
  const {
    groupedLines: t,
    subCategoryId: r,
    oddsStyle: n,
    selectedOutcomes: s,
    heading: o,
    eventStatus: i = "",
    isPlayerStatsEnabled: c = !1
  } = e, d = Object.keys(t), u = t[d[0]], b = t[d[1]], m = (R = (j = (O = u[0]) == null ? void 0 : O.participants) == null ? void 0 : j[0]) == null ? void 0 : R.statistic, p = u.findIndex((P) => {
    var D;
    return (D = P.tags) == null ? void 0 : D.includes("MainPointLine");
  }), S = p !== -1 ? p : Math.floor(u.length / 2), [v, C] = w.useState(S), [_, k] = w.useState(() => u[S].id), [h, g] = w.useState(!1), x = ce(u.length), E = w.useCallback(
    (P) => {
      C(P), k(u[P].id);
    },
    [u]
  ), N = (P) => {
    const D = u.findIndex((H) => H.id === P);
    E(D);
  };
  return q(() => {
    if (x && u.length !== x) {
      g(!0);
      const P = u.findIndex((D) => D.id === _);
      P > -1 && E(P), v > u.length - 1 && E(u.length - 1);
    }
  }, [u.length]), q(() => {
    if (!s || !Js(s) || !h || p === -1)
      return;
    const P = u[v], D = b[v];
    if (s.some((H) => H === P.id || H === D.id))
      E(v);
    else {
      let H = u.findIndex((G) => s.some((W) => W === G.id));
      H === -1 && (H = b.findIndex((G) => s.some((W) => W === G.id))), E(H >= 0 ? H : S);
    }
    g(!1);
  }, [s]), /* @__PURE__ */ a.jsxs("div", { className: "cb-move-the-line-wrapper", children: [
    o && /* @__PURE__ */ a.jsx("div", { className: "cb-move-the-line-wrapper__team-wrapper", children: /* @__PURE__ */ a.jsx(jr, { statistic: ge(i, m, c), children: /* @__PURE__ */ a.jsx("p", { className: "cb-move-the-line-wrapper__team-name", children: o }) }) }),
    /* @__PURE__ */ a.jsxs("div", { className: "cb-move-the-line-wrapper__cells", children: [
      /* @__PURE__ */ a.jsx(
        Qt,
        {
          selectedLineIndex: v,
          oddsStyle: n,
          ...u[v]
        }
      ),
      /* @__PURE__ */ a.jsx(
        Qt,
        {
          selectedLineIndex: v,
          oddsStyle: n,
          ...b[v]
        }
      )
    ] }, r),
    /* @__PURE__ */ a.jsx("div", { className: "cb-move-the-line-wrapper__line-picker", children: /* @__PURE__ */ a.jsx(
      Ks,
      {
        lines: u,
        selectedLineIndex: v,
        onSelectLine: N
      }
    ) })
  ] });
}, Qs = (e) => {
  const { setAdditionalHeight: t } = Be(), { disabled: r = !1, viewLessLabel: n = "View Less", viewMoreLabel: s = "View More", children: o } = e, i = w.useRef(null), [c, d] = w.useState(!1);
  if (r)
    return /* @__PURE__ */ a.jsx(a.Fragment, { children: o });
  const u = () => {
    const m = i.current;
    m && m.parentElement && (m.parentElement.style.setProperty("--expanded-content-height", `${m.offsetHeight}px`), t(c ? 0 : m.offsetHeight), d(!c));
  }, b = (m) => {
    m.stopPropagation(), u();
  };
  return /* @__PURE__ */ a.jsxs("div", { className: $("cb-view-more", { expanded: c }), children: [
    /* @__PURE__ */ a.jsx("div", { className: "cb-view-more__content", children: /* @__PURE__ */ a.jsx("div", { className: "cb-view-more__children", ref: i, children: o }) }),
    /* @__PURE__ */ a.jsx("button", { className: "cb-view-more__button", onClick: b, children: /* @__PURE__ */ a.jsxs("span", { children: [
      c ? n : s,
      /* @__PURE__ */ a.jsx(
        "svg",
        {
          role: "img",
          "aria-label": "Arrow pointing down icon",
          className: "cb-icon-arrow-down",
          fill: "#ababab",
          width: "12",
          height: "12",
          viewBox: "0 0 32 32",
          children: /* @__PURE__ */ a.jsx("path", { d: "M15.968 26.496h0.032l14.624-14.656c0.384-0.384 0.384-0.992 0-1.344l-1.504-1.504c-0.384-0.384-0.992-0.384-1.344 0l-11.744 11.776h-0.032l-11.776-11.776c-0.384-0.384-0.992-0.384-1.344 0l-1.504 1.504c-0.384 0.384-0.384 0.992 0 1.344l14.592 14.656z" })
        }
      )
    ] }) })
  ] });
}, ea = ({
  children: e,
  selections: t,
  oddsStyle: r,
  isMoveTheLineEnabled: n,
  selectedOutcomes: s,
  totalsHeading: o,
  eventStatus: i,
  isPlayerStatsEnabled: c
}) => {
  const d = !!(t != null && t.length), u = d ? t[0].subCategoryId : "", b = d ? zs(t, (S) => S.label) : {}, m = Object.keys(b).length === 2, p = n && m;
  return /* @__PURE__ */ a.jsxs("div", { className: "cb-move-the-line", children: [
    p && /* @__PURE__ */ a.jsx(
      Zs,
      {
        groupedLines: b,
        subCategoryId: u,
        oddsStyle: r,
        selectedOutcomes: s,
        heading: o,
        eventStatus: i,
        isPlayerStatsEnabled: c
      }
    ),
    /* @__PURE__ */ a.jsx(Qs, { disabled: !p, children: e })
  ] });
}, ta = {
  AutoGrid: function(t) {
    return /* @__PURE__ */ a.jsx(Le, { ...t });
  },
  FixedGrid: function(t) {
    return /* @__PURE__ */ a.jsx(Le, { fixedGridModifier: Qe.FixedGrid, ...t });
  },
  DualGrid: function(t) {
    return /* @__PURE__ */ a.jsx(Le, { dualGridModifier: Qe.DualGrid, ...t });
  },
  MoveTheLineGrid: function(t) {
    return /* @__PURE__ */ a.jsx(Ws, { children: /* @__PURE__ */ a.jsx(
      ea,
      {
        selections: t.selections,
        selectedOutcomes: t.selectedOutcomes,
        oddsStyle: t.oddsStyle,
        isMoveTheLineEnabled: !!t.productConfig.isMoveTheLineEnabled,
        totalsHeading: t.totalsHeading,
        eventStatus: t.eventStatus,
        isPlayerStatsEnabled: t.isPlayerStatsEnabled,
        children: /* @__PURE__ */ a.jsx(Le, { ...t })
      }
    ) });
  }
}, ra = {
  rootMargin: "0px",
  threshold: 0.01
};
function Lr(e) {
  const t = A.useRef(0), r = A.useRef({}), [n, s] = A.useState(!1), o = (d) => {
    d && r.current.unobserve(d);
  }, i = (d) => {
    d && r.current.observe(d);
  }, c = (d) => {
    window.cancelAnimationFrame(t.current), t.current = window.requestAnimationFrame(
      s.bind(Lr, d[0].isIntersecting)
    );
  };
  return q(() => {
    const d = Nr();
    r.current = new d(c, { ...ra, ...e }), s(r.current.faked || !1);
  }, []), {
    isVisible: n,
    domRegister: i,
    unRegisterDom: o
  };
}
const na = {
  sm: {
    width: 36,
    height: 36
  },
  md: {
    width: 140,
    height: 187
  },
  lg: {
    width: 160,
    height: 160
  }
}, sa = A.memo((e) => {
  const t = `${e.s3AssetsRoot}/DefaultPlayerImage.svg`, r = A.useRef(null), n = Lr({}), { dkPlayerId: s, size: o, isPlayerImageDisabled: i, trackEvent: c } = e, d = na[o], [u, b] = A.useState(t);
  q(() => {
    n.isVisible && s && !i && fetch(`${e.scoutBaseApiHost}v1/players/${s}/image?size=${o}`, {
      method: "GET",
      mode: "cors",
      headers: {
        "X-Client-Name": "web",
        "X-Client-Version": e.consumerVersion || "",
        "X-Client-Feature": "player-image",
        "X-Client-Page": e.page || "event",
        "X-Client-Widget-Name": e.widget || "EventPageWidget",
        "X-Client-Widget-Version": e.widgetVersion || ""
      }
    }).then((p) => {
      if (p.status >= 400)
        throw new Error(`${p.status} ${p.statusText}`);
      if (p.ok && p.status === 200)
        return p.blob();
    }).then((p) => {
      if (p) {
        const S = URL.createObjectURL(p);
        b(S);
      }
    }).catch((p) => {
      c("PLAYER_IMAGES_ERROR", {
        message: p.message,
        dkPlayerId: s
      });
    }).finally(() => n.unRegisterDom(r.current));
  }, [n.isVisible, s, i, e.scoutBaseApiHost]), q(() => {
    const p = r.current;
    return s && n.domRegister(p), () => n.unRegisterDom(p);
  }, []);
  const m = () => {
    var p;
    ((p = r.current) == null ? void 0 : p.src) !== t && URL.revokeObjectURL(u);
  };
  return /* @__PURE__ */ a.jsx(
    "img",
    {
      className: "cb-player-image",
      onLoad: m,
      src: u,
      alt: "player image",
      width: d.width,
      height: d.height,
      ref: r,
      "data-testid": "cb-player-image"
    }
  );
}), aa = ({
  playerName: e,
  playerId: t,
  getPlayerLink: r,
  onPlayerLinkClick: n,
  children: s
}) => {
  const [o, i] = A.useState(""), c = (d) => {
    d.preventDefault(), n(o);
  };
  return q(() => {
    i(r({ playerId: t, playerName: e }));
  }, [t, e]), /* @__PURE__ */ a.jsx("a", { href: o, onClick: c, className: "cb-player-page-link", "data-testid": "player-page-link", children: s });
}, oa = w.memo(
  function({ name: t }) {
    return /* @__PURE__ */ a.jsxs("p", { className: "selection-wrapper", "data-testid": "selection-wrapper-indicator", children: [
      /* @__PURE__ */ a.jsx("span", { className: "selection-indicator" }),
      /* @__PURE__ */ a.jsx("span", { className: "selection-name-wrapper", children: /* @__PURE__ */ a.jsx("span", { className: "selection-name", children: t }) })
    ] });
  }
), ia = (e) => {
  const t = le("label"), {
    isRowLabel: r,
    label: n,
    textAlignModifier: s = "center",
    productConfig: o,
    trackEvent: i,
    playerPageConfig: c,
    getPlayerLink: d,
    onPlayerLinkClick: u,
    isVerticalLabel: b,
    seoIdentifier: m,
    stretchColumn: p,
    statistic: S
  } = e, { s3AssetsRoot: v, scoutBaseApiHost: C } = o, { isPlayerImagesEnabled: _, isPlayerPagesEnabled: k } = c, h = e.playerId ? parseInt(e.playerId) : void 0, g = e.participantType === "Player", x = b && n && n.split(",").filter(Boolean), E = r && g && _, N = /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    E && /* @__PURE__ */ a.jsx(
      sa,
      {
        consumerVersion: e.consumerVersion,
        page: e.page,
        widget: e.widget,
        widgetVersion: e.widgetVersion,
        trackEvent: i,
        size: "sm",
        dkPlayerId: h,
        s3AssetsRoot: v,
        scoutBaseApiHost: C,
        isPlayerImageDisabled: !_
      }
    ),
    x ? /* @__PURE__ */ a.jsx("div", { className: `${t}--selections`, "data-testid": "selection-labels", children: x.map((j, R) => /* @__PURE__ */ a.jsx(oa, { name: j }, `${j}.${R}`)) }) : /* @__PURE__ */ a.jsx("p", { className: `${t}--truncate-strings`, children: n })
  ] }), O = /* @__PURE__ */ a.jsx(a.Fragment, { children: k && e.playerId ? /* @__PURE__ */ a.jsx(
    aa,
    {
      playerName: m || n,
      playerId: e.playerId,
      getPlayerLink: d,
      onPlayerLinkClick: u,
      children: N
    }
  ) : N });
  return /* @__PURE__ */ a.jsx(
    "div",
    {
      "data-testid": "market-label",
      className: $(t, {
        [`${t}--row`]: r,
        [`${t}--text-${s}`]: !b,
        [`${t}--vertical`]: b,
        [`${t}--stretch-column`]: p
      }),
      children: r ? /* @__PURE__ */ a.jsx(jr, { statistic: S, hasPlayerImages: E, children: O }) : O
    }
  );
}, la = ({ alt: e = "Arrow pointing up icon" }) => /* @__PURE__ */ a.jsx("svg", { role: "img", "aria-label": e, className: "cb-arrow--up", fill: "#ababab", width: "12", height: "12", viewBox: "0 0 32 32", children: /* @__PURE__ */ a.jsx("path", { d: "M16.032 6.144h-0.032l-14.624 14.656c-0.384 0.384-0.384 0.992 0 1.344l1.504 1.504c0.384 0.384 0.992 0.384 1.344 0l11.776-11.776h0.032l11.776 11.776c0.384 0.384 0.992 0.384 1.344 0l1.504-1.504c0.384-0.384 0.384-0.992 0-1.344l-14.624-14.656z" }) }), ca = ({ alt: e = "Arrow pointing down icon" }) => /* @__PURE__ */ a.jsx(
  "svg",
  {
    role: "img",
    "aria-label": e,
    className: "cb-arrow--down",
    fill: "#ababab",
    width: "12",
    height: "12",
    viewBox: "0 0 32 32",
    children: /* @__PURE__ */ a.jsx("path", { d: "M15.968 26.496h0.032l14.624-14.656c0.384-0.384 0.384-0.992 0-1.344l-1.504-1.504c-0.384-0.384-0.992-0.384-1.344 0l-11.744 11.776h-0.032l-11.776-11.776c-0.384-0.384-0.992-0.384-1.344 0l-1.504 1.504c-0.384 0.384-0.384 0.992 0 1.344l14.592 14.656z" })
  }
), yt = ({ trueOdds: e, onOddsUpdate: t, skipUpdate: r }) => {
  const [n, s] = we(e), [o, i] = we(null);
  pe(() => {
    r || (e > n ? (t(), c()) : e < n && (t(), d())), s(e);
  }, [e, n, t, r]);
  const c = () => {
    i("up");
  }, d = () => {
    i("down");
  }, u = () => {
    i(null);
  };
  return /* @__PURE__ */ a.jsxs("span", { "data-testid": "cb-odds-update-arrow", onAnimationEnd: u, className: "cb-odds-update-arrow", children: [
    o === "up" && /* @__PURE__ */ a.jsx(la, {}),
    o === "down" && /* @__PURE__ */ a.jsx(ca, {})
  ] });
}, rr = "odds-update-indicator", da = (e) => {
  const t = le("button"), r = ue(null), n = () => {
    e.onClick(e.selectionHandlerIDs);
  }, s = () => {
    r.current && r.current.classList.remove(rr);
  }, o = () => {
    r.current && r.current.classList.add(rr);
  }, { disabled: i, fixedGridLocation: c, isSelected: d, isLoading: u, children: b, modifier: m } = e;
  return /* @__PURE__ */ a.jsxs(
    "button",
    {
      "data-testid": "component-builder-market-button",
      ref: r,
      onAnimationEnd: s,
      type: "button",
      onClick: n,
      disabled: i,
      className: $(
        t,
        `${t}--${m}`,
        { [`${t}--selected`]: d },
        { [`${t}--loading`]: u },
        { [`${t}--grid-column-${c}`]: c }
      ),
      children: [
        /* @__PURE__ */ a.jsx(yt, { trueOdds: e.trueOdds, onOddsUpdate: o }),
        u && /* @__PURE__ */ a.jsx("div", { className: `${t}__animate-loading` }),
        b
      ]
    }
  );
}, rt = (e) => {
  const t = le("button");
  return /* @__PURE__ */ a.jsxs(
    da,
    {
      onClick: e.onClick,
      selectionHandlerIDs: e.selectionHandlerIDs,
      isSelected: e.isSelected,
      disabled: e.disabled,
      fixedGridLocation: e.fixedGridLocation,
      modifier: "regular",
      isLoading: e.isLoading,
      trueOdds: e.trueOdds,
      children: [
        e.label && /* @__PURE__ */ a.jsx("span", { className: `${t}-title`, "data-testid": "button-title-market-board", children: e.label }),
        e.points && /* @__PURE__ */ a.jsx("span", { className: `${t}-points`, "data-testid": "button-points-market-board", children: e.points }),
        /* @__PURE__ */ a.jsx("span", { className: `${t}-odds`, "data-testid": "button-odds-market-board", children: e.odds })
      ]
    }
  );
}, Ir = ({ fixedGridLocation: e }) => {
  const t = le("button");
  return /* @__PURE__ */ a.jsx(
    "div",
    {
      "data-testid": "button-component-builder-market-empty",
      className: $(t, `${t}--empty`, {
        [`${t}--grid-column-${e}`]: e
      })
    }
  );
}, He = "COMPONENT_BUILDER_TRACK", nt = {
  STARTED: "STARTED",
  FINISHED: "FINISHED",
  NOT_STARTED: "NOT_STARTED"
}, ua = ({
  alt: e = "Icon indicating a live or in-progress event"
}) => /* @__PURE__ */ a.jsxs(
  "svg",
  {
    role: "img",
    "data-testid": "live-badge",
    className: "sportsbook__icon--live",
    "aria-label": e,
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "16",
    viewBox: "0 0 24 16",
    fill: "none",
    children: [
      /* @__PURE__ */ a.jsx("rect", { x: "0.5", y: "0.5", width: "23", height: "15", rx: "1.5", fill: "white", fillOpacity: "0.1" }),
      /* @__PURE__ */ a.jsx(
        "path",
        {
          d: "M4.8784 11.5V4.62H6.2584V10.25H7.9984V11.5H4.8784ZM8.67746 11.5V4.62H10.0475V11.5H8.67746ZM11.9991 11.5L10.6791 4.62H12.0791L12.9791 10.06H13.0691L13.9391 4.62H15.3191L13.9991 11.5H11.9991ZM15.9526 11.5V4.62H19.2926V5.83H17.3326V7.42H19.0226V8.63H17.3326V10.29H19.2926V11.5H15.9526Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ a.jsx("rect", { x: "0.5", y: "0.5", width: "23", height: "15", rx: "1.5", stroke: "white" })
    ]
  }
), ma = A.memo(function(t) {
  return /* @__PURE__ */ a.jsxs(
    "svg",
    {
      "data-testid": "sgp-badge",
      className: t.className,
      width: "23",
      height: "16",
      viewBox: "0 0 23 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ a.jsx("rect", { x: "0.5", y: "0.5", width: "22", height: "15", rx: "1.5", fill: t.fillBackground }),
        /* @__PURE__ */ a.jsx(
          "path",
          {
            d: "M6.68363 11.58C6.40363 11.58 6.09697 11.5633 5.76363 11.53C5.43697 11.5033 5.14697 11.4633 4.89363 11.41V10.29C5.57363 10.3433 6.04363 10.37 6.30363 10.37C6.53697 10.37 6.71363 10.3567 6.83363 10.33C6.95363 10.3033 7.04363 10.2567 7.10363 10.19C7.15697 10.1367 7.1903 10.0633 7.20363 9.97C7.22363 9.87 7.23363 9.73 7.23363 9.55C7.23363 9.30333 7.2203 9.13 7.19363 9.03C7.16697 8.92333 7.1103 8.84667 7.02363 8.8C6.94363 8.74667 6.8003 8.7 6.59363 8.66L5.65363 8.49C5.3203 8.43 5.0903 8.24667 4.96363 7.94C4.83697 7.63333 4.77363 7.19 4.77363 6.61C4.77363 6.04333 4.85363 5.61 5.01363 5.31C5.1803 5.01 5.40697 4.80667 5.69363 4.7C5.9803 4.59333 6.34363 4.54 6.78363 4.54C7.0903 4.54 7.38363 4.56 7.66363 4.6C7.9503 4.64 8.18363 4.68 8.36363 4.72V5.84C8.00363 5.78 7.6003 5.75 7.15363 5.75C6.91363 5.75 6.72697 5.76 6.59363 5.78C6.46697 5.8 6.37363 5.83667 6.31363 5.89C6.2403 5.94333 6.19363 6.02 6.17363 6.12C6.15363 6.22 6.14363 6.36667 6.14363 6.56C6.14363 6.76667 6.15363 6.91667 6.17363 7.01C6.2003 7.10333 6.24363 7.17 6.30363 7.21C6.36363 7.25 6.46697 7.28333 6.61363 7.31L7.49363 7.47C7.72697 7.50333 7.92363 7.57667 8.08363 7.69C8.2503 7.79667 8.3803 7.97667 8.47363 8.23C8.56697 8.49667 8.61363 8.87333 8.61363 9.36C8.61363 9.99333 8.53697 10.47 8.38363 10.79C8.2303 11.11 8.01697 11.3233 7.74363 11.43C7.47697 11.53 7.12363 11.58 6.68363 11.58ZM11.4172 8.68V7.5H13.3072V11.37C13.0739 11.43 12.7906 11.48 12.4572 11.52C12.1239 11.56 11.8139 11.58 11.5272 11.58C10.8939 11.58 10.4206 11.4867 10.1072 11.3C9.80056 11.1067 9.58723 10.7667 9.46723 10.28C9.35389 9.78667 9.29723 9.04667 9.29723 8.06C9.29723 7.08 9.35723 6.34667 9.47723 5.86C9.60389 5.36667 9.83056 5.02333 10.1572 4.83C10.4839 4.63667 10.9739 4.54 11.6272 4.54C11.8939 4.54 12.1839 4.56 12.4972 4.6C12.8106 4.64 13.0772 4.68667 13.2972 4.74V5.87C12.7239 5.79 12.3072 5.75 12.0472 5.75C11.5939 5.75 11.2806 5.78667 11.1072 5.86C10.9406 5.93333 10.8239 6.12333 10.7572 6.43C10.6972 6.73 10.6672 7.27333 10.6672 8.06C10.6672 8.79333 10.6872 9.31667 10.7272 9.63C10.7672 9.93667 10.8439 10.1433 10.9572 10.25C11.0772 10.3567 11.2772 10.41 11.5572 10.41C11.6172 10.41 11.7772 10.4 12.0372 10.38V8.68H11.4172ZM14.3003 4.62H16.5703C17.0569 4.62 17.4236 4.70667 17.6703 4.88C17.9236 5.05333 18.0936 5.30667 18.1803 5.64C18.2669 5.96667 18.3103 6.40333 18.3103 6.95C18.3103 7.47667 18.2703 7.90667 18.1903 8.24C18.1103 8.56667 17.9436 8.82667 17.6903 9.02C17.4369 9.20667 17.0603 9.3 16.5603 9.3H15.6803V11.5H14.3003V4.62ZM16.2203 8.09C16.4469 8.09 16.6069 8.06333 16.7003 8.01C16.7936 7.95667 16.8536 7.85667 16.8803 7.71C16.9136 7.55667 16.9303 7.30333 16.9303 6.95C16.9303 6.59667 16.9136 6.34667 16.8803 6.2C16.8536 6.05333 16.7936 5.95667 16.7003 5.91C16.6136 5.85667 16.4569 5.83 16.2303 5.83H15.6803V8.09H16.2203Z",
            fill: t.fill
          }
        ),
        /* @__PURE__ */ a.jsx("rect", { x: "0.5", y: "0.5", width: "22", height: "15", rx: "1.5", stroke: t.fill })
      ]
    }
  );
}), pa = {
  fillBackground: "#12320B",
  fill: "#53D337"
}, Pe = {
  milestonesComponentNewBadgePlayerText: "Tap left or right to change the player's line.",
  milestonesComponentNewBadgeTeamText: "Tap left or right to change the team's line.",
  dkSquaresNewBadgeText: "Scroll through the available options to pick the desired combination.",
  sgpBadgeTitle: "Open game in SGP mode"
}, ba = ({ tags: e, renderSGPNavLink: t }) => Fn(e) ? /* @__PURE__ */ a.jsx("span", { className: "cb__sgp-badge-icon-title ", title: Pe.sgpBadgeTitle, children: /* @__PURE__ */ a.jsx(t, { children: /* @__PURE__ */ a.jsx(ma, { className: "cb__sgp-badge-icon", ...pa }) }) }) : /* @__PURE__ */ a.jsx(a.Fragment, {});
function fa(e) {
  return (t) => e(new Date(t).getTime());
}
function ha(e) {
  const t = new Date(e), r = t.getHours(), n = t.getMinutes(), s = r >= 12 ? "PM" : "AM", o = r % 12 || 12, i = n < 10 ? "0" + n : n;
  return `${o}:${i}${s}`;
}
const Sa = fa((e) => ha(e)), ga = ({
  eventStatus: e,
  tags: t,
  startEventDate: r,
  renderEventNavLink: n,
  renderSGPNavLink: s
}) => {
  const { minute: o, period: i, second: c, state: d } = e, u = c < 10 ? "0" + c : c, b = `${o}:${u}`, m = b === "0:00" ? "" : b, p = /* @__PURE__ */ a.jsx(ba, { tags: t, renderSGPNavLink: s });
  return d === nt.STARTED ? /* @__PURE__ */ a.jsxs("div", { className: "cb-event-cell__status cb-event-cell__status__position", children: [
    p,
    n && /* @__PURE__ */ a.jsx(n, { children: /* @__PURE__ */ a.jsxs("div", { className: "cb-event-link__wrapper", children: [
      /* @__PURE__ */ a.jsx(ua, {}),
      /* @__PURE__ */ a.jsxs("div", { className: "cb-event-cell__clock", children: [
        /* @__PURE__ */ a.jsx("span", { className: "cb-event-cell__time", children: m }),
        /* @__PURE__ */ a.jsx("span", { className: $("cb-event-cell__period", { borderless: m === "" }), children: i })
      ] })
    ] }) })
  ] }) : d === nt.NOT_STARTED ? /* @__PURE__ */ a.jsxs("div", { className: "cb-event-cell__status cb-event-cell__status__position", children: [
    p,
    /* @__PURE__ */ a.jsx("span", { className: "cb-event-cell__start-time", children: Sa(r) })
  ] }) : null;
}, va = ({
  className: e,
  isRowLabel: t,
  textAlignModifier: r,
  label: n,
  subLabel: s,
  teamScore: o,
  renderEventNavLink: i,
  logoUrl: c,
  getTeamLogo: d,
  showEventStatusAndLink: u
}) => /* @__PURE__ */ a.jsxs(
  "p",
  {
    className: $(e, `${e}-parlay ${e}-text-${r}`, {
      [`${e}-row`]: t,
      [`${e}-row-with-sublabel`]: s,
      [`${e}-row-with-team-score`]: o,
      [`${e}-row-without-logo`]: !c
    }),
    "data-testid": "label-parlay",
    children: [
      /* @__PURE__ */ a.jsxs(
        "div",
        {
          className: $(`${e}-team-content-wrapper`, {
            [`${e}-team-content-wrapper--with-score`]: o
          }),
          children: [
            c && d && /* @__PURE__ */ a.jsx(
              d,
              {
                className: `${e}-team-logo`,
                alt: `${n}-logo`,
                src: c,
                onErrorBehaviour: "hide",
                "data-testid": "cb-market-label-team-logo"
              }
            ),
            i && u ? /* @__PURE__ */ a.jsx(i, { children: /* @__PURE__ */ a.jsx("div", { className: `${e}-team-wrapper`, children: /* @__PURE__ */ a.jsxs("div", { className: `${e}-team-wrapper ${e}-team-wrapper--col`, children: [
              /* @__PURE__ */ a.jsx("span", { className: `${e}-inner ${e}-inner--parlay`, children: n }),
              s && /* @__PURE__ */ a.jsx("span", { className: `${e}-sub-label`, children: s })
            ] }) }) }) : /* @__PURE__ */ a.jsxs("div", { className: `${e}-team-wrapper ${e}-team-wrapper--col`, children: [
              /* @__PURE__ */ a.jsx("span", { className: `${e}-inner ${e}-inner--parlay`, children: n }),
              s && /* @__PURE__ */ a.jsx("span", { className: `${e}-sub-label`, children: s })
            ] })
          ]
        }
      ),
      o && /* @__PURE__ */ a.jsx("span", { className: `${e}-team-score`, children: o })
    ]
  }
), ya = ({
  isRowLabel: e,
  textAlignModifier: t = "center",
  label: r,
  subLabel: n,
  teamScore: s,
  renderEventNavLink: o,
  renderSGPNavLink: i,
  parsedEventState: c,
  tags: d,
  startEventDate: u,
  logoUrl: b,
  getTeamLogo: m,
  consumerPageName: p
}) => {
  const S = le("label"), v = p !== "EventPage", C = A.useMemo(
    () => v && c && d && u && i && o && /* @__PURE__ */ a.jsx(
      ga,
      {
        "data-testid": "event-status",
        eventStatus: c,
        tags: d,
        startEventDate: u,
        renderSGPNavLink: i,
        renderEventNavLink: o
      }
    ),
    [v, c, d, u, i, o]
  );
  return /* @__PURE__ */ a.jsxs("div", { className: `${S}-wrapper`, children: [
    C,
    /* @__PURE__ */ a.jsx(
      va,
      {
        className: S,
        isRowLabel: e,
        textAlignModifier: t,
        label: r,
        subLabel: n,
        teamScore: s,
        renderEventNavLink: o,
        logoUrl: b,
        getTeamLogo: m,
        showEventStatusAndLink: v
      }
    )
  ] });
}, xa = w.memo(
  function(t) {
    const r = t.buttons.length > t.btnExpandableColumns, n = le("expandable"), [s, o] = w.useState(!1), i = w.useRef(null), [c, d] = w.useState("none"), u = typeof c == "number", { additionalHeight: b, setAdditionalHeight: m } = Be();
    q(() => {
      s && i.current !== null ? (d(i.current.scrollHeight), m(b + i.current.scrollHeight)) : (d(0), m(0));
    }, [s]);
    const p = w.useCallback(() => {
      o(!s);
    }, [s]), S = t.buttons.slice(0, t.btnExpandableColumns);
    return /* @__PURE__ */ a.jsxs("div", { className: n, "data-collapsed": !s, "data-testid": "market-button-expandable", children: [
      /* @__PURE__ */ a.jsxs("div", { className: `${n}__primary`, children: [
        /* @__PURE__ */ a.jsx("div", { className: `${n}__primary-btn-wrapper`, children: S.map((v, C) => /* @__PURE__ */ at(rt, { ...v, key: C })) }),
        r && /* @__PURE__ */ a.jsx("button", { type: "button", className: `${n}-arrow-wrapper`, onClick: p, children: /* @__PURE__ */ a.jsx("div", { className: `${n}-arrow`, children: /* @__PURE__ */ a.jsx(
          "svg",
          {
            role: "img",
            className: $(
              `${n}-arrow__${s ? "up" : "down"}`,
              `${n}-arrow-inner`
            ),
            viewBox: "0 0 32 32",
            children: /* @__PURE__ */ a.jsx("path", { d: "M16.032 6.144h-0.032l-14.624 14.656c-0.384 0.384-0.384 0.992 0 1.344l1.504 1.504c0.384 0.384 0.992 0.384 1.344 0l11.776-11.776h0.032l11.776 11.776c0.384 0.384 0.992 0.384 1.344 0l1.504-1.504c0.384-0.384 0.384-0.992 0-1.344l-14.624-14.656z" })
          }
        ) }) })
      ] }),
      r && u && /* @__PURE__ */ a.jsx(
        "div",
        {
          className: $(
            `${n}__content`,
            `${n}__content--${t.btnExpandableColumns}-column`
          ),
          children: /* @__PURE__ */ a.jsx(
            "div",
            {
              ref: i,
              style: {
                maxHeight: `${c}px`,
                overflow: "hidden",
                transition: `max-height ${t.animation.duration}ms ${t.animation.ease}`
              },
              className: `${n}__secondary`,
              children: t.buttons.slice(t.btnExpandableColumns).map((v) => /* @__PURE__ */ a.jsx(
                rt,
                {
                  ...v
                },
                `market-button-secondary-${v.selectionHandlerIDs.selectionId}`
              ))
            }
          )
        }
      )
    ] });
  }
), Ca = (e) => {
  const t = le("labelName");
  return /* @__PURE__ */ a.jsx("p", { className: $(t, { [`${t}--row`]: e.isRowLabel }), children: e.label });
}, wa = w.memo(
  ({
    selection: e,
    index: t,
    focusedSelectionIndex: r,
    isDisabled: n,
    onSelectionClick: s,
    onOddsUpdate: o,
    handleAnimationEnd: i,
    buttonRef: c,
    oddsStyle: d
  }) => {
    const u = t === r;
    return /* @__PURE__ */ a.jsxs(
      "button",
      {
        ref: u ? c : null,
        "data-testid": `cb-selection-picker__selection-${t}`,
        onAnimationEnd: i,
        disabled: n,
        onClick: () => s(t),
        className: $(
          "cb-selection-picker__selection",
          { "cb-selection-picker__selection--focused": u },
          { "cb-selection-picker__selection--prev": t === r - 1 },
          { "cb-selection-picker__selection--next": t === r + 1 },
          { "cb-selection-picker__selection--selected": e.isSelected },
          { "cb-selection-picker__selection--disabled": n },
          { "cb-selection-picker__selection--loading": u && e.isLoading }
        ),
        children: [
          /* @__PURE__ */ a.jsx("span", { className: "cb-selection-picker__selection-label", children: e.label }),
          u && /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
            /* @__PURE__ */ a.jsx(yt, { trueOdds: e.trueOdds, onOddsUpdate: o }),
            e.isLoading && /* @__PURE__ */ a.jsx("div", { className: "cb-selection-picker__animate-loading" }),
            /* @__PURE__ */ a.jsx("span", { className: "cb-selection-picker__selection-odds", children: e.displayOdds[d] })
          ] })
        ]
      }
    );
  }
), nr = ({ direction: e, onClick: t, isDisabled: r }) => {
  const n = e === "left";
  return /* @__PURE__ */ a.jsx(
    "button",
    {
      "data-testid": `cb-selection-picker__${e}-arrow`,
      className: `cb-selection-picker__${e}-arrow`,
      disabled: r,
      onClick: t,
      children: /* @__PURE__ */ a.jsx(
        "svg",
        {
          width: "16",
          height: "24",
          viewBox: "0 0 16 24",
          role: "img",
          "aria-label": `Arrow pointing ${e} icon`,
          className: `cb-icon--arrow-${e}`,
          xmlns: "http://www.w3.org/2000/svg",
          children: /* @__PURE__ */ a.jsx(
            "path",
            {
              d: n ? "M10 6L6 12L10 18" : "M6 6L10 12L6 18",
              stroke: "#ABABAB",
              strokeWidth: "2",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }
          )
        }
      )
    }
  );
}, sr = (e, t) => {
  const n = e.getBoundingClientRect().width / 3;
  return t.current === 0 ? n : (1 - t.current) * n;
}, Fe = {
  MILESTONES_COMPONENT_NAVIGATION_TRACKING_KEY: "MilestonesComponentNavigation",
  MILESTONES_COMPONENT_SELECT_TRACKING_KEY: "MilestonesComponentSelect",
  MILESTONES_COMPONENT_NEW_BADGE_LOCAL_STORAGE: "isMilestonesComponentNewBadgeDisabled"
};
function _a(e, t) {
  e(He, {
    type: Fe.MILESTONES_COMPONENT_NAVIGATION_TRACKING_KEY,
    page: t.page,
    text: t.text,
    odds: t.odds,
    rank: t.rank
  });
}
function ka(e, t) {
  e(He, {
    type: Fe.MILESTONES_COMPONENT_SELECT_TRACKING_KEY,
    action: t.action,
    leagueId: t.leagueId,
    selectionId: t.selectionId,
    page: t.page,
    text: t.text,
    odds: t.odds,
    rank: t.rank
  });
}
const Ta = () => /* @__PURE__ */ a.jsx("svg", { width: "23", height: "24", viewBox: "0 0 23 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ a.jsx("g", { opacity: "0.1", children: /* @__PURE__ */ a.jsx(
  "path",
  {
    d: "M22.3786 6.2207C22.5687 6.13377 22.7643 6.08417 22.961 6.05129C22.4495 7.17585 22.0079 8.33385 21.6377 9.51859C21.3789 10.3484 21.155 11.1921 20.9694 12.0458C20.71 13.2339 20.3338 15.5254 20.3338 15.5254C20.3005 15.8123 19.8483 16.4064 19.4227 16.5892C19.3485 16.6215 19.292 16.568 19.267 16.5346C19.2382 16.495 19.2964 16.4281 19.3252 16.3908C19.5923 16.0414 19.6189 15.7817 19.5496 15.4273C19.3873 14.5953 16.571 14.4872 13.0643 15.3816C9.55759 16.276 7.15918 17.7316 7.41465 18.5385C7.52382 18.8823 7.67123 19.0963 8.07299 19.2735C8.11622 19.2925 8.19934 19.3214 8.19269 19.3699C8.18715 19.4117 8.16332 19.4847 8.08297 19.492C7.62246 19.5382 6.9414 19.2339 6.7746 18.9988C6.7746 18.9988 5.41358 17.1498 4.61781 16.2353C4.04536 15.5772 3.44465 14.9346 2.82067 14.3334C1.92903 13.4746 0.986404 12.6515 0 11.9143C0.18786 11.8474 0.382924 11.7521 0.591288 11.7359C1.47739 11.668 2.28646 12.3534 2.72702 12.7374H2.72923C3.06062 12.3534 3.71952 11.639 4.5164 11.5376C4.53635 11.6356 4.55187 11.8246 4.55907 11.9265C4.61116 12.6175 4.3568 13.2606 3.91181 13.7209C4.54189 14.0625 5.25288 14.2553 5.98936 14.267C6.15283 14.2531 6.31686 14.2158 6.47702 14.1522C7.1675 13.8792 7.58977 13.216 7.59143 12.5122C8.04972 12.8053 8.63546 12.8822 9.17965 12.6671C9.47834 12.5496 9.72605 12.3584 9.91225 12.1227C9.99205 11.994 10.0663 11.8619 10.1328 11.7259C10.1605 11.6691 10.1871 11.6122 10.212 11.5548C10.4168 10.9215 10.6192 10.2945 10.6011 9.58937C10.5928 9.29401 10.5562 8.99532 10.4886 8.69663C10.4764 8.7022 10.4642 8.70777 10.452 8.71279C9.80696 8.97972 9.04998 8.95074 8.40216 8.56846C8.33456 8.52889 8.27028 8.48598 8.20876 8.44084C8.24035 8.37063 8.27582 8.30208 8.31572 8.2341C8.65542 7.65231 9.20847 7.27449 9.81693 7.1413C9.88898 7.1257 9.96268 7.11344 10.0364 7.10452C9.62519 6.40181 9.50383 5.05044 9.94384 4.29758C9.9926 4.21288 10.0469 4.13374 10.1051 4.05796L10.15 4L10.2159 4.02675C10.3029 4.0652 10.4265 4.12371 10.5102 4.17387C11.2561 4.62079 11.864 5.84622 11.8407 6.6615C11.9094 6.63363 11.9793 6.60856 12.0508 6.58738C12.647 6.40961 13.3131 6.47258 13.89 6.81753C13.9571 6.85821 14.0208 6.90112 14.0823 6.94682C14.0502 7.01647 14.0141 7.08502 13.9742 7.15245C13.5897 7.80166 12.9402 8.19342 12.2469 8.27199C12.2336 8.27366 12.2203 8.27478 12.2076 8.27589C12.2913 8.57013 12.4021 8.84988 12.5367 9.11179C12.8798 9.78162 13.3763 10.3417 13.9704 10.758C14.0712 10.8287 14.1754 10.8939 14.2818 10.9558C14.5539 11.0722 14.8587 11.1207 15.1734 11.0834C15.7536 11.0137 16.2341 10.6671 16.4995 10.1907C16.832 10.8092 17.5164 11.1932 18.2529 11.1051C18.5494 11.0695 18.8048 11.0059 19.0337 10.8454C19.5773 10.491 20.0334 10.0274 20.3776 9.49129C19.7669 9.30349 19.236 8.86325 18.95 8.23298C18.9079 8.13936 18.8736 8.04407 18.8442 7.94934C19.5906 7.65064 20.4086 7.77213 21.0276 8.21125L21.0292 8.21069C21.0758 7.37591 21.5695 6.59072 22.3786 6.2207Z",
    fill: "white"
  }
) }) }), ar = ({ leftSide: e, shouldAnimate: t }) => /* @__PURE__ */ a.jsx(
  "span",
  {
    "data-testid": "cb-selection-picker__selection-empty",
    className: $("cb-selection-picker__selection-empty", {
      "cb-selection-picker__selection-empty--left": e,
      "cb-selection-picker__selection-empty--right": !e,
      "cb-selection-picker__selection-empty--animate-left": e && t,
      "cb-selection-picker__selection-empty--animate-right": !e && t
    }),
    style: e ? { left: "-2px" } : { right: "0" },
    children: /* @__PURE__ */ a.jsx(Ta, {})
  }
), { enableScroll: or, disableScroll: Ea } = gt(), ir = "odds-update-indicator", Na = (e) => {
  const {
    selections: t,
    focusedSelectionIndex: r,
    onSelectionFocus: n,
    oddsStyle: s,
    mainOutcomeIndex: o,
    trackEvent: i,
    page: c,
    leagueId: d,
    shouldAnimate: u,
    onAnimationEnd: b
  } = e, m = t == null ? void 0 : t[0].isDisabled, p = fr(), S = w.useRef(null), v = w.useRef(null), C = w.useRef(null), _ = w.useRef(r), [k, h] = w.useState(0), g = ce(r), x = () => p(() => {
    if (S.current && v.current && S.current.querySelector(
      ".cb-selection-picker__selection--focused"
    )) {
      const X = sr(S.current, _);
      Re(v.current, { duration: 0, start: k, end: X }), h(X);
    }
  }, 25), E = () => !m && Ea(), N = () => or(), O = () => {
    const F = t[r - 1];
    F && n(F.id);
  }, j = () => {
    const F = t[r + 1];
    F && n(F.id);
  }, R = m ? void 0 : vt(j, O, m), P = (F) => {
    const X = t[F];
    F === r ? X.selectionHandlerIDs && X.onSelectionClick && (ka(i, {
      action: X.isSelected ? "Deselected" : "Selected",
      leagueId: d,
      odds: X.displayOdds[s],
      page: c,
      rank: F - o,
      selectionId: X.id,
      text: X.label
    }), X.onSelectionClick(X.selectionHandlerIDs)) : n(X.id);
  }, D = () => {
    C.current && C.current.classList.add(ir);
  }, H = () => {
    C.current && C.current.classList.remove(ir);
  };
  q(() => (x(), window.addEventListener("resize", x), () => {
    window.removeEventListener("resize", x), R == null || R.cancel({ upcomingOnly: !0 }), or();
  }), []), q(() => {
    if (_.current = r, g === void 0 || !v.current)
      return;
    const F = sr(v.current, _);
    Re(
      v.current,
      { duration: u ? 300 : 0, start: k, end: F },
      b
    ), h(F);
  }, [r]);
  const G = _.current > 0, W = _.current < t.length - 1;
  return /* @__PURE__ */ a.jsxs(
    "div",
    {
      onWheel: R,
      onMouseEnter: E,
      onMouseLeave: N,
      className: $("cb-selection-picker", { "cb-selection-picker--disabled": m }),
      "data-testid": "cb-selection-picker",
      children: [
        G ? /* @__PURE__ */ a.jsx(nr, { direction: "left", onClick: O, isDisabled: m }) : /* @__PURE__ */ a.jsx(ar, { leftSide: !0, shouldAnimate: u }),
        /* @__PURE__ */ a.jsx("div", { ref: S, className: "cb-selection-picker__selections-wrapper", children: /* @__PURE__ */ a.jsx("div", { ref: v, className: "cb-selection-picker__selections-animation", children: t.map((F, X) => /* @__PURE__ */ a.jsx(
          wa,
          {
            selection: F,
            index: X,
            focusedSelectionIndex: r,
            isDisabled: m,
            onSelectionClick: P,
            onOddsUpdate: D,
            handleAnimationEnd: H,
            buttonRef: C,
            oddsStyle: s
          },
          F.id
        )) }) }),
        W ? /* @__PURE__ */ a.jsx(nr, { direction: "right", onClick: j, isDisabled: m }) : /* @__PURE__ */ a.jsx(ar, { shouldAnimate: u })
      ]
    }
  );
}, Rr = {
  storage: window.localStorage
};
function Mr(e) {
  if (typeof window < "u") {
    const t = window.localStorage.getItem(
      Fe.MILESTONES_COMPONENT_NEW_BADGE_LOCAL_STORAGE
    );
    return t ? t !== "true" : e;
  }
  return !1;
}
const Pr = A.forwardRef((e, t) => {
  const { text: r, onClick: n, className: s, dataTestId: o, headerText: i } = e;
  return /* @__PURE__ */ a.jsxs("div", { className: $(s, "cb-new-badge"), ref: t, "data-testid": o, children: [
    i && /* @__PURE__ */ a.jsx("h4", { className: "cb-new-badge__header", children: i }),
    /* @__PURE__ */ a.jsx("span", { className: "cb-new-badge__text", children: r }),
    /* @__PURE__ */ a.jsx("button", { type: "button", className: "cb-new-badge__close", onClick: n, children: /* @__PURE__ */ a.jsxs(
      "svg",
      {
        className: "cb-new-badge__close-icon",
        xmlns: "http://www.w3.org/2000/svg",
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        children: [
          /* @__PURE__ */ a.jsx("path", { d: "M9.5 2.5L2.5 9.5", stroke: "white" }),
          /* @__PURE__ */ a.jsx("path", { d: "M2.5 2.5L9.5 9.5", stroke: "white" })
        ]
      }
    ) })
  ] });
}), Oa = A.memo(
  ({ milestonesNewBadgeEnabled: e, isPlayerMarket: t }) => {
    const r = A.useRef(null), [n, s] = A.useState(
      Mr(e)
    );
    pe(() => {
      !n && Rr.storage.setItem(
        Fe.MILESTONES_COMPONENT_NEW_BADGE_LOCAL_STORAGE,
        "true"
      );
    }, [n]);
    const o = (i) => {
      i.preventDefault(), i.stopPropagation(), s(!1);
    };
    return n ? /* @__PURE__ */ a.jsx(
      Pr,
      {
        text: t ? Pe.milestonesComponentNewBadgePlayerText : Pe.milestonesComponentNewBadgeTeamText,
        dataTestId: "cb-milestones-new-badge",
        onClick: o,
        ref: r
      }
    ) : null;
  }
);
function Ar({ page: e, isBadgeEnabled: t, badgeSelector: r }) {
  if (t && e !== null) {
    const n = e.querySelector(r);
    if (n instanceof HTMLElement)
      return n.style.display = "flex", n;
  }
}
const ja = (e) => {
  var h;
  const {
    parsedSelections: t,
    productConfig: r,
    isFirstMarket: n,
    marketboardRef: s,
    trackEvent: o,
    consumerPageName: i,
    leagueId: c,
    oddsStyle: d,
    isPlayerMarket: u
  } = e, b = t.findIndex(
    (g) => {
      var x;
      return (x = g.tags) == null ? void 0 : x.includes("MostBalancedOdds");
    }
  ), m = b !== -1 ? b : t.length > 1 ? Math.ceil(t.length / 2) : 0, [p, S] = A.useState(m), v = ue((h = t[p]) == null ? void 0 : h.id), C = ue(t.length), _ = ue(!1), k = (g) => {
    var N, O;
    _.current = !0;
    const x = t.findIndex((j) => j.id === g);
    S(x), v.current = g, t[x] && _a(o, {
      page: i,
      text: (N = t[x]) == null ? void 0 : N.label,
      odds: (O = t[x]) == null ? void 0 : O.displayOdds[d],
      rank: x - m
    });
  };
  return q(() => {
    if (t.length === C.current) return;
    if (p > t.length - 1) {
      S(t.length - 1), C.current = t.length;
      return;
    }
    const g = t.findIndex((x) => x.id === v.current);
    g !== -1 && g !== p ? (S(g), v.current = t[g].id, _.current = g === C.current) : v.current = t[p].id, C.current = t.length;
  }, [t.length]), pe(() => {
    Ar({
      page: s.current,
      isBadgeEnabled: Mr(
        r.milestonesComponentConfig.isMilestonesTooltipEnabled
      ),
      badgeSelector: "[data-testid='cb-milestones-new-badge']"
    });
  }, [r.milestonesComponentConfig.isMilestonesTooltipEnabled, s]), /* @__PURE__ */ a.jsxs("div", { className: "cb-market-buttons-slider", "data-testid": "cb-market-buttons-slider", children: [
    /* @__PURE__ */ a.jsx(
      Na,
      {
        selections: t,
        focusedSelectionIndex: p,
        oddsStyle: d,
        onSelectionFocus: k,
        mainOutcomeIndex: m,
        trackEvent: o,
        page: i,
        leagueId: c,
        shouldAnimate: _.current,
        onAnimationEnd: () => _.current = !0
      }
    ),
    n && /* @__PURE__ */ a.jsx(
      Oa,
      {
        milestonesNewBadgeEnabled: r.milestonesComponentConfig.isMilestonesTooltipEnabled,
        isPlayerMarket: u
      }
    )
  ] });
}, { enableScroll: La, disableScroll: Ia } = gt(), Ra = w.memo((e) => {
  const { scores: t, onSelectResult: r, selectedScoreIndex: n, teamRGB: s, disabled: o } = e, i = ce(n), c = ce(t) || [], d = w.useRef(null), u = w.useRef(null), b = s && !o ? {
    background: `radial-gradient(circle, rgba(${s.r}, ${s.g}, ${s.b}, 0.5), transparent 60%)`
  } : {}, m = () => {
    d.current && u.current && (Y(d.current, { start: 0, end: 100 }), Y(u.current, { start: -100, end: 0 }));
  }, p = () => {
    d.current && u.current && (Y(d.current, { start: 0, end: -100 }), Y(u.current, { start: 100, end: 0 }));
  };
  q(() => {
    i !== void 0 && i !== n && c[i] !== t[n] && (n > i ? m() : p());
  }, [n]);
  const S = () => {
    const h = n - 1;
    t[h] && !o && r(t[h]);
  }, v = () => {
    const h = n + 1;
    t[h] && !o && r(t[h]);
  }, C = vt(S, v, !1), _ = () => Ia(), k = () => La();
  return /* @__PURE__ */ a.jsxs(
    "div",
    {
      onWheel: C,
      onMouseEnter: _,
      onMouseLeave: k,
      className: $("cb-result-picker", { disabled: o }),
      "data-testid": "result-picker",
      children: [
        /* @__PURE__ */ a.jsx(
          "div",
          {
            className: $("cb-result-picker__up-arrow", {
              disabled: n === t.length - 1 || o
            }),
            onClick: v,
            children: /* @__PURE__ */ a.jsx(
              "svg",
              {
                role: "img",
                "aria-label": "Arrow pointing up icon",
                className: "cb-icon--arrow-up",
                fill: "#ababab",
                width: "20",
                height: "20",
                viewBox: "0 0 32 32",
                children: /* @__PURE__ */ a.jsx("path", { d: "M16.032 5.504h-0.032l-14.624 14.656c-0.384 0.384-0.384 0.992 0 1.344l1.504 1.504c0.384 0.384 0.992 0.384 1.344 0l11.744-11.776h0.032l11.776 11.776c0.384 0.384 0.992 0.384 1.344 0l1.504-1.504c0.384-0.384 0.384-0.992 0-1.344l-14.592-14.656z" })
              }
            )
          }
        ),
        /* @__PURE__ */ a.jsxs("div", { className: "cb-result-picker__lines-wrapper", style: b, children: [
          /* @__PURE__ */ a.jsx("div", { className: "cb-result-picker__line-glow" }),
          /* @__PURE__ */ a.jsxs("div", { className: "cb-result-picker__lines-animation", children: [
            /* @__PURE__ */ a.jsx("div", { className: "cb-result-picker__line-prev", ref: d, children: t[i ?? n] }),
            /* @__PURE__ */ a.jsx("div", { className: "cb-result-picker__line-curr", ref: u, children: t[n] })
          ] })
        ] }),
        /* @__PURE__ */ a.jsx(
          "div",
          {
            className: $("cb-result-picker__down-arrow", { disabled: n === 0 || o }),
            onClick: S,
            children: /* @__PURE__ */ a.jsx(
              "svg",
              {
                role: "img",
                "aria-label": "Arrow pointing down icon",
                className: "cb-icon--arrow-down",
                fill: "#ababab",
                width: "20",
                height: "20",
                viewBox: "0 0 32 32",
                children: /* @__PURE__ */ a.jsx("path", { d: "M16.032 26.464v-0.032l14.624-14.624c0.384-0.384 0.384-0.992 0-1.344l-1.504-1.504c-0.384-0.384-0.992-0.384-1.344 0l-11.776 11.776h-0.032l-11.744-11.776c-0.384-0.384-0.992-0.384-1.344 0l-1.504 1.504c-0.384 0.384-0.384 0.992 0 1.344l14.592 14.624z" })
              }
            )
          }
        )
      ]
    }
  );
}), st = A.memo((e) => {
  const { logoUrl: t, name: r } = e;
  return /* @__PURE__ */ a.jsx(a.Fragment, { children: /* @__PURE__ */ a.jsxs("div", { className: "cb-participant-logo-wapper", children: [
    t && /* @__PURE__ */ a.jsx("div", { className: "cb-scores-team-logo-wrapper", children: /* @__PURE__ */ a.jsx(
      e.getTeamLogo,
      {
        className: "cb-scores-team-logo",
        alt: `${r}-logo`,
        src: t,
        onErrorBehaviour: "hide",
        "data-testid": "cb-scoreboard-team-logo"
      }
    ) }),
    /* @__PURE__ */ a.jsx("span", { className: "cb-participan-name", children: r })
  ] }) });
}), Ma = ({ alt: e = "Icon representing a refresh action" }) => /* @__PURE__ */ a.jsxs(
  "svg",
  {
    role: "img",
    "aria-labelledby": "title",
    className: "cb-icon--refresh",
    fill: "#ababab",
    width: "15",
    height: "15",
    viewBox: "0 0 32 32",
    children: [
      /* @__PURE__ */ a.jsx("title", { children: e }),
      /* @__PURE__ */ a.jsx("path", { d: "M28.32 18.624l-8.832 1.76c-0.224 0.064-0.384 0.288-0.384 0.576l0.352 1.92c0.064 0.224 0.32 0.448 0.576 0.384l3.008-0.64c-1.824 2.112-4.448 3.296-7.264 3.296-4.704 0-8.768-3.36-9.6-7.968l-4.416 1.248c1.44 6.528 7.328 11.264 14.016 11.264 4.224 0 8.128-1.824 10.848-4.992l0.48 2.048c0.064 0.224 0.288 0.384 0.576 0.384l1.92-0.352c0.224-0.064 0.384-0.288 0.384-0.576l-1.664-8.352zM3.552 13.664l8.832-1.76c0.224-0.064 0.384-0.288 0.384-0.576l-0.352-1.92c-0.064-0.224-0.32-0.448-0.576-0.384l-3.008 0.64c1.856-2.144 4.48-3.36 7.264-3.36 4.704 0 8.768 3.36 9.6 7.968l4.416-1.248c-1.44-6.464-7.328-11.2-14.016-11.2-4.224 0-8.128 1.824-10.848 4.992l-0.48-2.368c-0.064-0.224-0.288-0.384-0.576-0.384l-1.92 0.352c-0.224 0.064-0.384 0.288-0.384 0.576l1.664 8.672z" })
    ]
  }
), Pa = (e) => {
  const { participants: t, scoresMap: r, onSelectedScore: n, resetScore: s, disabled: o } = e;
  return /* @__PURE__ */ a.jsx("div", { className: "cb-participant-picker-container", children: t.map((i, c) => {
    const d = c % 2 === 0, u = d ? "scoreHome" : "scoreAway", b = d ? r == null ? void 0 : r.scoreHome : r == null ? void 0 : r.scoreAway, m = Xn(i.teamColor), p = m ? {
      background: d ? `radial-gradient(circle at top left, rgba(${m.r}, ${m.g}, ${m.b}, 0.5), transparent 65%)` : `radial-gradient(circle at top right, rgba(${m.r}, ${m.g}, ${m.b}, 0.5), transparent 65%)`
    } : {}, S = i.scores.filter((C) => C !== ""), v = S.findIndex((C) => C === b);
    return /* @__PURE__ */ a.jsxs(A.Fragment, { children: [
      /* @__PURE__ */ a.jsxs(
        "div",
        {
          className: $({
            "cb-participant-picker-container-row": d,
            "cb-participant-picker-container-row-reverse": !d
          }),
          style: p,
          children: [
            /* @__PURE__ */ a.jsx(
              st,
              {
                logoUrl: i.logoUrl,
                name: i.name,
                getTeamLogo: e.getTeamLogo
              },
              `${i.id}.${i.name}-logo-name`
            ),
            /* @__PURE__ */ a.jsx(
              Ra,
              {
                teamRGB: m,
                disabled: o,
                scores: S,
                selectedScoreIndex: v !== -1 ? v : 0,
                onSelectResult: (C) => n(u, C)
              }
            )
          ]
        },
        `${i.id}.${i.name}`
      ),
      c === 0 && /* @__PURE__ */ a.jsx(
        "div",
        {
          className: $("cb-refresh-container", { disabled: o }),
          onClick: () => {
            o || s();
          },
          children: /* @__PURE__ */ a.jsxs("div", { className: "cb-refresh-button", children: [
            /* @__PURE__ */ a.jsx(Ma, {}),
            /* @__PURE__ */ a.jsx("span", { className: "cb-refresh-text", children: "Reset Numbers" })
          ] })
        }
      )
    ] }, `${i.id}`);
  }) });
}, Se = {
  Dk_Squares_COMPONENT_NEW_BADGE_LOCAL_STORAGE: "isDkSquaresComponentNewBadgeDisabled",
  Dk_Squares_COMPONENT_SELECT_TRACKING_KEY: "DkSquaresComponentSelect",
  Correct_Score_COMPONENT_SELECT_TRACKING_KEY: "Correct_Score_COMPONENT_SELECT_TRACKING_KEY"
};
function Aa(e, t) {
  const r = t.marketName.replace(/\s+/g, "").toLowerCase().includes("dksquares") ? Se.Dk_Squares_COMPONENT_SELECT_TRACKING_KEY : Se.Correct_Score_COMPONENT_SELECT_TRACKING_KEY;
  e(He, {
    type: r,
    action: t.action,
    eventId: t.eventId,
    selectionId: t.selectionId,
    page: t.page,
    text: t.text,
    marketName: t.marketName,
    odds: t.odds,
    elementType: t.elementType
  });
}
function $a(e, t) {
  const r = t.marketName.replace(/\s+/g, "").toLowerCase().includes("dksquares") ? Se.Dk_Squares_COMPONENT_SELECT_TRACKING_KEY : Se.Correct_Score_COMPONENT_SELECT_TRACKING_KEY;
  e(He, {
    type: r,
    action: t.action,
    eventId: t.eventId,
    selectionId: t.selectionId,
    page: t.page,
    text: t.text,
    marketName: t.marketName
  });
}
const lr = "odds-update-indicator", $r = (e) => {
  const {
    isDisabled: t,
    isSelected: r,
    displayOdds: n = {},
    label: s,
    oddsStyle: o,
    selectionHandlerIDs: i,
    isLoading: c,
    onSelectionClick: d,
    trackEvent: u,
    eventId: b,
    id: m,
    marketName: p,
    consumerPageName: S,
    trueOdds: v,
    elementType: C = "Button"
  } = e, _ = r || t || c, { decimal: k } = n, h = ce(n), g = ce(s) || "", x = w.useRef(null), E = w.useRef(null), N = w.useRef(null), O = w.useRef(null), j = w.useRef(null), R = () => {
    E.current && N.current && (Y(E.current, { start: 0, end: 100 }), Y(N.current, { start: -100, end: 0 })), O.current && j.current && (Y(O.current, { start: 0, end: 100 }), Y(j.current, { start: -100, end: 0 }));
  }, P = () => {
    E.current && N.current && (Y(E.current, { start: 0, end: -100 }), Y(N.current, { start: 100, end: 0 })), O.current && j.current && (Y(O.current, { start: 0, end: -100 }), Y(j.current, { start: 100, end: 0 }));
  };
  q(() => {
    s && g && (s > g ? R() : P());
  }, [s]);
  const D = () => {
    x.current && x.current.classList.remove(lr);
  }, H = (W) => {
    W.stopPropagation(), !t && i && d && (Aa(u, {
      action: r ? "Deselected" : "Selected",
      eventId: b,
      odds: k,
      page: S,
      selectionId: m,
      text: s,
      marketName: p || "",
      elementType: C
    }), d(i));
  }, G = () => {
    x.current && x.current.classList.add(lr);
  };
  return /* @__PURE__ */ a.jsxs(
    "div",
    {
      "aria-pressed": r,
      ref: x,
      "data-testid": "outcome-cell",
      onClick: H,
      onAnimationEnd: D,
      className: $(
        "cb-outcome-cell-wrapper",
        { selected: r },
        { disabled: t },
        { loading: c }
      ),
      children: [
        c && /* @__PURE__ */ a.jsx("div", { className: "cb-outcome-cell__animate-loading" }),
        /* @__PURE__ */ a.jsx(yt, { trueOdds: v, onOddsUpdate: G, skipUpdate: g !== s }),
        /* @__PURE__ */ a.jsxs("div", { className: "cb-outcome-cell-wrapper__line", children: [
          /* @__PURE__ */ a.jsx("div", { className: "cb-outcome-cell-wrapper__line-prev", ref: E, "data-testid": "prev-line-value", children: g }),
          /* @__PURE__ */ a.jsx("div", { className: "cb-outcome-cell-wrapper__line-curr", ref: N, "data-testid": "curr-line-value", children: s })
        ] }),
        /* @__PURE__ */ a.jsxs("div", { className: "cb-outcome-cell-wrapper__odds", children: [
          /* @__PURE__ */ a.jsx("div", { className: "cb-outcome-cell-wrapper__odds-prev", ref: O, children: /* @__PURE__ */ a.jsx(Me, { noMargin: !0, colorOverride: _, oddsStyle: o, displayOdds: h }) }),
          /* @__PURE__ */ a.jsx("div", { className: "cb-outcome-cell-wrapper__odds-curr", ref: j, children: /* @__PURE__ */ a.jsx(Me, { noMargin: !0, colorOverride: _, oddsStyle: o, displayOdds: n }) })
        ] })
      ]
    }
  );
};
function Dr(e) {
  if (typeof window < "u") {
    const t = window.localStorage.getItem(Se.Dk_Squares_COMPONENT_NEW_BADGE_LOCAL_STORAGE);
    return t ? t !== "true" : e;
  }
  return !1;
}
const Da = A.memo(
  ({ dkSquaresNewBadgeEnabled: e, marketName: t }) => {
    const r = A.useRef(null), [n, s] = A.useState(Dr(e));
    pe(() => {
      !n && Rr.storage.setItem(
        Se.Dk_Squares_COMPONENT_NEW_BADGE_LOCAL_STORAGE,
        "true"
      );
    }, [n]);
    const o = (i) => {
      i.preventDefault(), i.stopPropagation(), s(!1);
    };
    return n ? /* @__PURE__ */ a.jsx(
      Pr,
      {
        text: Pe.dkSquaresNewBadgeText,
        dataTestId: "cb-dk-squares-new-badge",
        onClick: o,
        className: "cb-dk-squares-new-badge",
        ref: r,
        headerText: t
      }
    ) : null;
  }
), Ba = (e) => {
  const { participants: t, parsedSelections: r, oddsStyle: n, consumerPageName: s, trackEvent: o, gridSize: i } = e, [c, d] = t, u = c.scores, b = d.scores, m = Array.from({ length: i }, (p, S) => S);
  return /* @__PURE__ */ a.jsx("div", { className: "table-odds-wrapper", children: /* @__PURE__ */ a.jsxs("div", { className: "table-container", children: [
    /* @__PURE__ */ a.jsxs("div", { className: "cb-row", children: [
      /* @__PURE__ */ a.jsx("div", { className: "cb-header-cell" }),
      m.map((p, S) => /* @__PURE__ */ a.jsx("div", { className: "cb-header-cell", children: p }, `header-${p}-${S}`)),
      /* @__PURE__ */ a.jsx("div", { className: "cb-header-cell", children: /* @__PURE__ */ a.jsx(
        st,
        {
          logoUrl: d.logoUrl,
          name: d.name,
          getTeamLogo: e.getTeamLogo
        }
      ) })
    ] }),
    m.map((p, S) => {
      const v = u[S];
      return /* @__PURE__ */ a.jsxs("div", { className: "cb-row", children: [
        /* @__PURE__ */ a.jsx("div", { className: "cb-header-cell", children: p }, "headerTwo-header"),
        m.map((C, _) => {
          const k = b[_], h = `${v}:${k}`, g = r[h];
          return g ? /* @__PURE__ */ at(
            $r,
            {
              ...g,
              label: "",
              oddsStyle: n,
              trackEvent: o,
              consumerPageName: s,
              elementType: "tableGridButton",
              key: `${h}-${_}`
            }
          ) : /* @__PURE__ */ a.jsx("div", { className: "cb-empty-cell-wrapper" }, `${p}:${C}-${_}`);
        }),
        /* @__PURE__ */ a.jsx("div", { className: "cb-header-cell" }, `haeder-empty-${S}`)
      ] }, `row-${S}`);
    }),
    /* @__PURE__ */ a.jsx("div", { className: "cb-logo-x-axis", children: /* @__PURE__ */ a.jsx(
      st,
      {
        logoUrl: c.logoUrl,
        name: c.name,
        getTeamLogo: e.getTeamLogo
      }
    ) })
  ] }) });
}, Ha = (e) => {
  var N, O, j, R, P;
  const {
    participants: t,
    parsedSelections: r,
    oddsStyle: n,
    isTooltipEnabled: s,
    isFirstMarket: o,
    showTable: i,
    trackEvent: c,
    consumerPageName: d,
    marketboardRef: u,
    gridSize: b,
    isMarketSuspended: m
  } = e, p = A.useRef(null), { setAdditionalHeight: S } = Be(), v = Object.values(r), C = v.findIndex((D) => {
    var H;
    return (H = D.tags) == null ? void 0 : H.includes("MostBalancedOdds");
  }), _ = C !== -1 ? C : 0, [k, h] = we({
    scoreHome: Q((O = (N = v[_]) == null ? void 0 : N.metadata) == null ? void 0 : O.scoreHome, ""),
    scoreAway: Q((R = (j = v[_]) == null ? void 0 : j.metadata) == null ? void 0 : R.scoreAway, "")
  }), g = r[`${k.scoreHome}:${k.scoreAway}`], x = (D, H) => {
    h({
      ...k,
      [D]: H
    });
  }, E = () => {
    var D, H, G, W;
    $a(c, {
      page: d,
      marketName: (g == null ? void 0 : g.marketName) || "",
      action: "Reset",
      eventId: g == null ? void 0 : g.eventId,
      selectionId: g == null ? void 0 : g.id,
      text: g == null ? void 0 : g.label
    }), h({
      scoreHome: Q((H = (D = v[_]) == null ? void 0 : D.metadata) == null ? void 0 : H.scoreHome, ""),
      scoreAway: Q((W = (G = v[_]) == null ? void 0 : G.metadata) == null ? void 0 : W.scoreAway, "")
    });
  };
  return pe(() => {
    var D;
    Ar({
      page: u.current,
      isBadgeEnabled: Dr(s),
      badgeSelector: "[data-testid='cb-dk-squares-new-badge']"
    }), S(((D = p.current) == null ? void 0 : D.offsetHeight) || 0);
  }, [s, u, S]), /* @__PURE__ */ a.jsxs("div", { className: "cb-market-participant-wrapper", children: [
    /* @__PURE__ */ a.jsx(
      Pa,
      {
        participants: t,
        scoresMap: k,
        getTeamLogo: e.getTeamLogo,
        onSelectedScore: x,
        resetScore: E,
        disabled: m
      }
    ),
    /* @__PURE__ */ a.jsx("div", { className: "cb-market-participant-button-wrapper", children: g ? /* @__PURE__ */ a.jsx(
      $r,
      {
        ...g,
        oddsStyle: n,
        trackEvent: c,
        consumerPageName: d
      }
    ) : /* @__PURE__ */ a.jsx(Ir, {}) }),
    o && /* @__PURE__ */ a.jsx(
      "div",
      {
        ref: p,
        className: $({
          "cb-badge-wrapper": i,
          "cb-badge-wrapper-relative": !i
        }),
        children: /* @__PURE__ */ a.jsx(
          Da,
          {
            marketName: (P = v[0]) == null ? void 0 : P.marketName,
            dkSquaresNewBadgeEnabled: s
          }
        )
      }
    ),
    i && /* @__PURE__ */ a.jsx(
      Ba,
      {
        participants: t,
        parsedSelections: r,
        oddsStyle: n,
        getTeamLogo: e.getTeamLogo,
        trackEvent: c,
        consumerPageName: d,
        gridSize: b
      }
    )
  ] });
}, Fa = {
  Label(e) {
    return /* @__PURE__ */ a.jsx(ia, { ...e });
  },
  LabelParlay(e) {
    return /* @__PURE__ */ a.jsx(ya, { ...e });
  },
  LabelName(e) {
    return /* @__PURE__ */ a.jsx(Ca, { ...e });
  },
  Button(e) {
    return /* @__PURE__ */ a.jsx(rt, { ...e });
  },
  ButtonEmpty(e) {
    return /* @__PURE__ */ a.jsx(Ir, { ...e });
  },
  ButtonExpandable(e) {
    return /* @__PURE__ */ a.jsx(xa, { ...e });
  },
  MarketButtonsSlider(e) {
    return /* @__PURE__ */ a.jsx(ja, { ...e });
  },
  MarketParticipantsScores(e) {
    return Object.values(e.parsedSelections).length > 0 ? /* @__PURE__ */ a.jsx(Ha, { ...e }) : /* @__PURE__ */ a.jsx(a.Fragment, {});
  },
  Separator() {
    return /* @__PURE__ */ a.jsx("div", { className: "cb-market-cells-separator", "data-testid": "market-cells-separator" });
  }
};
function Ga({ type: e, props: t }) {
  return Fa[e]({ ...t });
}
const Wa = ({
  templateName: e,
  columns: t,
  truncateStrings: r,
  cells: n,
  selections: s,
  selectedOutcomes: o,
  oddsStyle: i,
  productConfig: c,
  totalsHeading: d,
  eventStatus: u,
  isPlayerStatsEnabled: b,
  playerPageConfig: m,
  consumerVersion: p,
  page: S,
  widget: v,
  widgetVersion: C,
  getPlayerLink: _,
  onPlayerLinkClick: k,
  trackEvent: h,
  marketboardRef: g,
  getTeamLogo: x,
  scoreboardComponent: E
}) => {
  const N = ta[e];
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    E,
    /* @__PURE__ */ a.jsx(
      N,
      {
        columns: t,
        truncateStrings: r,
        selections: s,
        selectedOutcomes: o,
        oddsStyle: i,
        productConfig: c,
        totalsHeading: d,
        eventStatus: u,
        isPlayerStatsEnabled: b,
        children: n.map((O) => /* @__PURE__ */ a.jsx(
          Ga,
          {
            type: O.type,
            props: {
              ...O.props,
              productConfig: c,
              trackEvent: h,
              playerPageConfig: m,
              getPlayerLink: _,
              onPlayerLinkClick: k,
              consumerVersion: p,
              page: S,
              widget: v,
              widgetVersion: C,
              marketboardRef: g,
              getTeamLogo: x
            }
          },
          O.id
        ))
      }
    )
  ] });
};
export {
  He as COMPONENT_BUILDER_TRACKING_KEY,
  Or as CollapsedMarketHeightContext,
  Ms as CollapsedMarketHeightContextProvider,
  $s as Collapsible,
  Pe as Dict,
  nt as EVENT_STATES,
  Er as FakeIntersectionObserver,
  Wa as MarketMapping,
  ta as MarketTemplate,
  Xa as MarketsCategory,
  sa as PlayerImage,
  aa as PlayerLink,
  Ja as SubCategoryLazyRender,
  Fs as SubCategoryLazyRenderContainer,
  Gs as SubCategoryLazyRenderContainerWithRef,
  De as SubCategoryLazyRenderContext,
  qa as SubCategoryMapping,
  Ga as TemplateCell,
  U as TemplateColumns,
  Qe as TemplateModifiers,
  ba as ToggleSGPBadge,
  Re as animateLinePicker,
  mt as autoGridMapperByName,
  $n as autoGridMapperByNameForDynamicOutcomes,
  An as autoGridMapperByOutcomeType,
  Mn as autoGridMapperByOutcomeTypePositiveNegativePoints,
  Dn as autoGridMapperByParticipant,
  Tn as compareByMarketAndTrueOdds,
  Os as compareChildren,
  te as compareSelection,
  ts as component11Mapper,
  ht as component12Mapper,
  ys as component18Mapper,
  ls as component202Mapper,
  ds as component203Mapper,
  vr as component204Mapper,
  Qn as component205Mapper,
  is as component210Mapper,
  cs as component212Mapper,
  bs as component214Mapper,
  rs as component231Mapper,
  ps as component240Mapper,
  _r as component250Mapper,
  ws as component255Mapper,
  ft as component29Mapper,
  es as component30Mapper,
  vs as component310Mapper,
  Zn as component330Mapper,
  xs as component331Mapper,
  Gn as component7Mapper,
  Jn as component8Mapper,
  Rr as componentBuilderConfig,
  yr as createMapper,
  vt as createThrottleOnWheel,
  je as findSelectionByOutcomeTypeOrLabel,
  Nr as getIntersectionObserverConstructor,
  le as getMarketComponentPrefix,
  gt as getScrollUtils,
  kn as getSwappedParticipants,
  pr as groupedByGoalscorer,
  In as groupedByLabelAndMarketName,
  On as groupedByLine,
  jn as groupedByOutcomeType,
  Ln as groupedByOutcomeTypeAndPoints,
  Rn as groupedByParticipant,
  Fn as hasSGPBagde,
  Xn as hexToRgb,
  re as mapToButton,
  br as mapToButtonExpandable,
  me as mapToEmptyButton,
  K as mapToLabel,
  Bn as mapToMarketButtonsSlider,
  Hn as mapToMarketParticipantsScores,
  he as mapToNameLabel,
  pt as mapToSeparator,
  Ka as marketCellsBuilder,
  Pn as moveTheLineGridMapper,
  it as parseMoveTheLineSelection,
  ee as parseSelection,
  _s as templateTypeMapper,
  Be as useAdditionalHeight,
  q as useEffectOptionalDeps,
  ce as usePrevious,
  Ps as withCollapsedMarketHeightContext
};
//# sourceMappingURL=index.js.map
